import http from '../../services/http-common';
import { 
  PdfGrid, PdfPen, PdfBitmap, PdfBrushes, PdfDocument, PdfBorders, PdfPage, 
  PdfColor, PdfSolidBrush, PdfFontStyle, PdfPageSize, PdfPageOrientation, 
  PdfAlignmentStyle, PdfStringFormat, PdfTextAlignment, PdfStandardFont, PointF,PdfVerticalAlignment,PdfPaddings,
  PdfFontFamily ,PdfMargins,PdfLayoutType,PdfLayoutFormat,PdfWordWrapType
} from "@syncfusion/ej2-pdf-export"; 
import moment from 'moment';


class SaleInvoiceService {
  getForList() {
    return http.get(`/digitalInvoicing/getSaleInvoice`);
    // return http.get(`/digitalInvoicing/pdi/v1/provinces?CompanyID=1`);
  }
  getSaleInvoiceForList(SaleInvoiceID , IsProduction =0) {
    return http.get(`/digitalInvoicing/getSaleInvoiceForList?SaleInvoiceID=${SaleInvoiceID}&IsProduction=${IsProduction}`);
    // return http.get(`/digitalInvoicing/pdi/v1/provinces?CompanyID=1`);
  }
  getCompanyView() {
    return http.get(`/digitalInvoicing/getCompanyView`);
  }
  getBuyerRegistrationType(data) {
    let queryParams = new URLSearchParams({CompanyID:data.CompanyID}).toString();
    return http.post(`/digitalInvoicing/dist/v1/Get_Reg_Type_axios  ` ,data);
  }

  getsaleTypeDataSource(CompanyID) {
    let queryParams = new URLSearchParams({CompanyID:CompanyID}).toString();
    return http.get(`/digitalInvoicing/pdi/v1/transtypecode?${queryParams}`);
  }
  
  getItemDescCode(CompanyID) {
    let queryParams = new URLSearchParams({CompanyID:CompanyID}).toString();
    return http.get(`/digitalInvoicing/pdi/v1/itemdesccode?${queryParams}`);
  }
  
  getRateDDSource(data) {
    let queryParams = new URLSearchParams(data).toString();
    return http.get(`/digitalInvoicing/pdi/v2/SaleTypeToRate?${queryParams}`);
  }
  getUOMDDSource(data) {
    let queryParams = new URLSearchParams(data).toString();
    return http.get(`/digitalInvoicing/pdi/v2/HS_UOM?${queryParams}`);
  }
  
  validatePostData(CompanyID , data) {
    let queryParams = new URLSearchParams({CompanyID}).toString();
    return http.post(`/digitalInvoicing/di_data/v1/di/validateinvoicedata?${queryParams}`,data);
  }
  validatePostDataTesting(CompanyID , data) {
    let queryParams = new URLSearchParams({CompanyID}).toString();
    return http.post(`/digitalInvoicing/di_data/v1/di/validateinvoicedata_sb?${queryParams}`,data);
  }
  getSroScheduleDD(data) {
    let queryParams = new URLSearchParams(data).toString();
    return http.get(`/digitalInvoicing/pdi/v1/SroSchedule?${queryParams}`);
  }
  
  getSroItemCode(data) {
    let queryParams = new URLSearchParams(data).toString();
    return http.get(`/digitalInvoicing/pdi/v2/SROItem?${queryParams}`);
  }
  
  
  getDoctypeCode(CompanyID) {
    let queryParams = new URLSearchParams({CompanyID}).toString();
    return http.get(`/digitalInvoicing/pdi/v1/doctypecode?${queryParams}`);
  }
  
  
  PostData(CompanyID , data) {
    let queryParams = new URLSearchParams({CompanyID}).toString();
    return http.post(`/digitalInvoicing/di_data/v1/di/postinvoicedata?${queryParams}`,data);
  }
  
  PostDataTesting(CompanyID , data) {
    let queryParams = new URLSearchParams({CompanyID}).toString();
    return http.post(`/digitalInvoicing/di_data/v1/di/postinvoicedata_sb?${queryParams}`,data);
  }
  
  
  
  
  
  deleteInvoice(data) {
    return http.delete(`/digitalInvoicing/di_data/v1/di/deleteTransaction?SaleInvoiceID=${data.SaleInvoiceID}`);
  }
  getChallanForSaleInvoice(data) {
    return http.get(`/digitalInvoicing/GetChallanForSaleInvoice?BuyerNTNCNIC=${data.BuyerNTNCNIC}`);
  }


  insert(data) {
    return http.post(`/digitalInvoicing/di_data/v1/di/SaleInvoiceDetail`, data);
  }
  updateInvoices(data) {
    return http.put(`/digitalInvoicing/di_data/v1/di/updateFBRInvoiceInfo`, data);
  }
  create(data) {
    return http.post(`/SaleInvoice/add`, data);
  }

  update(data) {
    return http.put(`/SaleInvoice/update`, data);
  }


  getDetail(id) {
  return http.get(`/digitalInvoicing/SaleInvoice/detailRows/${id}`);
}
getProvincesDD(id){
  return http.get(`/digitalInvoicing/pdi/v1/provinces?CompanyID=${id}`);
}

getCompanyID() {
  return this.getCompanyView()
    .then(response => {
      const companyID = response?.data?.recordset?.[0]?.CompanyID;
      return companyID; // return only the value
    })
    .catch(error => {
      console.error("Error fetching CompanyID:", error);
      return null;
    });
}
getImportExcelDD (entity,dataObject){
  console.log({entity:dataObject})
  
  switch (entity) {
    case "UOMDD":
      const data = {
        // CompanyID:this.getCompanyID(),
        CompanyID:1,
        hs_code:dataObject.hS_CODE,
        annexure_id:3
    }
      return this.getUOMDDSource(data)
      break;
    case "sroScheduleNoDD":
      const dataSroScheduleNoDD =  {
        rate_id:dataObject.rate,
        date: dataObject.invoiceDate,
        origination_supplier_csv:dataObject.buyerProvinceCode,
        // CompanyID:this.getCompanyID()
        CompanyID:1
    }
      return this.getSroScheduleDD(dataSroScheduleNoDD)
      break;
    case "sroItemSerialNoDD":
      const dataSroItemSerialNoDD =  {
        sro_id:dataObject.sroScheduleNoID,
        date: dataObject.invoiceDate,
        // CompanyID:this.getCompanyID()
        CompanyID:1
    }
      return this.getSroItemCode(dataSroItemSerialNoDD)
      break;
  
    default:
      break;
  }
}














  // ========= GENERATING SALE INVOICE REPORT ==============


  //  wrapText(graphics, text, font, brush, x, y, maxWidth, lineHeight) {
  //   const words = text.split(" ");
  //   let line = "";
  //   let yOffset = y;
  
  //   for (let i = 0; i < words.length; i++) {
  //     const testLine = line + words[i] + " ";
  //     const testWidth = font.measureString(testLine).width;
  
  //     if (testWidth > maxWidth && i > 0) {
  //       graphics.drawString(line.trim(), font, null, brush, x, yOffset);
  //       line = words[i] + " ";
  //       yOffset += lineHeight;
  //     } else {
  //       line = testLine;
  //     }
  //   }
  
  //   if (line) {
  //     graphics.drawString(line.trim(), font, null, brush, x, yOffset);
  //   }
  // }
  wrapText(graphics, text, font, brush, x, y, maxWidth, lineHeight) {
    const words = String(text ?? "").split(" ");
    let line = "";
    let yOffset = y;
  
    for (let i = 0; i < words.length; i++) {
      const testLine = line + words[i] + " ";
      const testWidth = font.measureString(testLine).width;
  
      if (testWidth > maxWidth && i > 0) {
        graphics.drawString(line.trim(), font, null, brush, x, yOffset);
        line = words[i] + " ";
        yOffset += lineHeight;
      } else {
        line = testLine;
      }
    }
  
    if (line) {
      graphics.drawString(line.trim(), font, null, brush, x, yOffset);
    }
  
    // IMPORTANT: return last drawn Y so caller can continue below it
    return yOffset;
  }
  
  async SalesTaxInvoiceReport   (invoiceDetails, invoiceItems,blob, type = 'download') {
    const document = new PdfDocument();
  
    // Page settings
    document.pageSettings.margins.all = 10;
    document.pageSettings.margins.bottom = 5;
    document.pageSettings.size = PdfPageSize.a4;
  
    // Add page
    const page = document.pages.add();
    let  graphics = page.graphics;
  
    // Fonts & brushes
    const headerFont = new PdfStandardFont(PdfFontFamily.Helvetica, 16, PdfFontStyle.Bold);
    const subFont = new PdfStandardFont(PdfFontFamily.Helvetica, 8);
    const subBoldFont = new PdfStandardFont(PdfFontFamily.Helvetica, 8, PdfFontStyle.Bold);
    const boldFont = new PdfStandardFont(PdfFontFamily.Helvetica, 9, PdfFontStyle.Bold);
    const boldFonts = new PdfStandardFont(PdfFontFamily.Helvetica, 10, PdfFontStyle.Bold);
    
    const blackBrush = new PdfSolidBrush(new PdfColor(0, 0, 0));
    const pageWidth = page.getClientSize().width;
    // ===== Header =====
    if(invoiceDetails.sellerLogo && invoiceDetails.sellerLogo    != ''){
    const logoBytes =invoiceDetails.sellerLogo
    
    //  // ===== IMAGE (Base64 PNG) =====
    const blobToBase641 = (blob) => {
      return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result.split(',')[1]); // Extract only Base64 data
          reader.onerror = reject;
          reader.readAsDataURL(blob);
      });
    };
  
  

      const url1 = URL.createObjectURL(logoBytes);

      const response1 = await fetch(url1);
      if (!response1.ok) throw new Error(`Failed to fetch image: ${response1.statusText}`);
    
      const imageBlob1 = await response1.blob();
      const imageBase641 = await blobToBase641(imageBlob1);
    
     // Create PdfBitmap from Base64
     
       

  const imageBase64s = new PdfBitmap(imageBase641);


// Get original dimensions
const originalWidth = imageBase64s.width;
const originalHeight = imageBase64s.height;

// Max allowed size
const maxWidth = 110;
const maxHeight = 110;

// Calculate scale ratio
const widthRatio = maxWidth / originalWidth;
const heightRatio = maxHeight / originalHeight;
const scale = Math.min(widthRatio, heightRatio);

// New scaled size
const newWidth = originalWidth * scale;
const newHeight = originalHeight * scale;

// Draw image centered (optional)
const x = 10;
const y = 10;

graphics.drawImage(imageBase64s, x, y, newWidth, newHeight)

  // graphics.drawImage(imageBase64s, 10, 10, 60, 60);



    }







    // Create PdfBitmap from Base64
  // if(invoiceDetails.sellerLogo){
    //  // ===== IMAGE (Base64 PNG) =====
    
      // const response = await fetch(url);
      // if (!response.ok) throw new Error(`Failed to fetch image: ${response.statusText}`);
    
      // const imageBlob = await response.blob();
      // const imageBase64 = await blobToBase64(invoiceDetails.sellerLogo);
      // const imageBase64 = ;
    //   console.log(imageBase64)
    // const imageD = new PdfBitmap(invoiceDetails.sellerLogo);
       
    // // Draw the image on the PDF
    // let xImgPos = page.getClientSize().width - 115;  // right aligned box
    //  let yImgPos =  170; 
    //  graphics.drawImage(imageD, 10, 140,96 ,96 ); // Adjust x, y, width, height as needed
  // }

    graphics.drawString("Sales Tax Invoice", headerFont, null, blackBrush, 220, 30);

    graphics.drawString("SOFTWARE  ID:", boldFont, null, blackBrush, 350, 120 - 16);
    graphics.drawString(`${String(invoiceDetails.SaleInvoiceID).padStart(4, '0')}`, subFont, null, blackBrush, 440, 120-16+1);
    graphics.drawString("DATE:", boldFont, null, blackBrush, 350, 120);
    graphics.drawString(`${moment(invoiceDetails.date).format("DD-MMM-YY")}`, subFont, null, blackBrush, 440, 121);
  
    // // ===== Buyer Info =====
    // graphics.drawString("INVOICE:", boldFont, null, blackBrush, 10, 35);
    // graphics.drawString(`${(invoiceDetails.invoiceNo).toUpperCase()}`, subFont, null, blackBrush, 55, 36);

    // graphics.drawString("BUYER:", boldFont, null, blackBrush, 10, 65);
    // // graphics.drawString(invoiceDetails.buyerName.toUpperCase(), subFont, null, blackBrush, 10, 85);
    //  this.wrapText(graphics,invoiceDetails.buyerName.toUpperCase(), subFont, blackBrush, 10, 80, 280, 10);
    // //  this.wrapText(graphics,'National Absorbent Cotton Mills Co TEXTILE'.toUpperCase(), subFont, blackBrush, 10, 80, 280, 10);
    
    
    // // graphics.drawString(invoiceDetails.sellerAddress, subFont, null, blackBrush, 400, 105);
    // this.wrapText(graphics, invoiceDetails.buyerAddress.toUpperCase(), subFont, blackBrush, 10, 90, 270, 10);
    // // this.wrapText(graphics, 'National Absorbent Cotton Mills Co INTERNATIONAL TEXTILE National Absorbent Cotton Mills Co INTERNATIONAL TEXTILE'.toUpperCase(), subFont, blackBrush, 10, 90, 270, 10);
    
    
    // graphics.drawString(`REGION:`, boldFont, null, blackBrush, 10, 115);
    // graphics.drawString(`${(invoiceDetails.buyerRegion).toUpperCase()}`, subFont, null, blackBrush, 50, 116);
    
    // graphics.drawString(`NTN:`, boldFont, null, blackBrush, 10, 130);

    // graphics.drawString(`${invoiceDetails.buyerNTN.toUpperCase()}`, subFont, null, blackBrush, 35, 131);
    
    // graphics.drawString(`TYPE:`, boldFont, null, blackBrush, 10, 145);

    // graphics.drawString(`${invoiceDetails.buyerType.toUpperCase()}`, subFont, null, blackBrush, 40, 146);
    
    // graphics.drawString(`SALE TYPE:`, boldFont, null, blackBrush, 10, 160);

    // graphics.drawString(`${invoiceDetails.saleType ? invoiceDetails.saleType.toUpperCase() : ''}`, subFont, null, blackBrush, 68, 161);
  
    // // ===== Seller Info =====
    // graphics.drawString("SELLER:", boldFont, null, blackBrush, 350, 65);
    // // graphics.drawString(invoiceDetails.sellerName, subFont, null, blackBrush, 400, 90);
    // this.wrapText(graphics, invoiceDetails.sellerName, subFont, blackBrush, 350, 80, 200, 10);
    
    // // graphics.drawString(invoiceDetails.sellerAddress, subFont, null, blackBrush, 400, 105);
    // this.wrapText(graphics, invoiceDetails.sellerAddress, subFont, blackBrush, 350, 90, 200, 10);
    

    // graphics.drawString(`REGION:`, boldFont, null, blackBrush, 350, 115);
    // graphics.drawString(`${(invoiceDetails.sellerRegion).toUpperCase()}`, subFont, null, blackBrush, 390, 116);
    
    // graphics.drawString(`NTN:`, boldFont, null, blackBrush, 350, 130);
    // graphics.drawString(`${invoiceDetails.sellerNTN.toUpperCase()}`, subFont, null, blackBrush, 3110, 131);
    


    //  graphics.drawString(`TYPE:`, boldFont, null, blackBrush, 350, 145);

    // graphics.drawString(`REGISTERED`, subFont, null, blackBrush, 380, 146);


    // ---------- helpers ----------
// const hasValue = (v) => v !== null && v !== undefined && String(v).trim() !== "";

const lineH10 = 10;     // for wrap text
const rowGap = 15;      // standard row vertical gap

const buyerX = 10;
const sellerX = 350;

const buyerLabelX = buyerX;
const sellerLabelX = sellerX;

// fixed indent so values align nicely
const buyerValueX = buyerX + 90;
const sellerValueX = sellerX + 90;

// available widths for wrapped values
const buyerValueWidth = 280 - 90; // block width ~280, minus indent
const sellerValueWidth = 200 - 90; // block width ~200, minus indent

const hasValue = (v) => v !== null && v !== undefined && String(v).trim() !== "";

const drawOptionalRowPair = (y, caption, buyerVal, sellerVal) => {
  // Row show ONLY if either side has value
  if (!hasValue(buyerVal) && !hasValue(sellerVal)) return y;

  // captions on BOTH sides
  graphics.drawString(`${caption}:`, boldFont, null, blackBrush, buyerLabelX, y);
  graphics.drawString(`${caption}:`, boldFont, null, blackBrush, sellerLabelX, y);

  // values (only where present)
  const buyerEndY = hasValue(buyerVal)
    ? this.wrapText(graphics, String(buyerVal), subFont, blackBrush, buyerValueX, y + 1, buyerValueWidth, lineH10)
    : y;

  const sellerEndY = hasValue(sellerVal)
    ? this.wrapText(graphics, String(sellerVal), subFont, blackBrush, sellerValueX, y + 1, sellerValueWidth, lineH10)
    : y;

  // next row starts after the longer (wrapped) side
  return Math.max(buyerEndY, sellerEndY) + rowGap;
};

// ---------- Reference No. above INVOICE ----------

// ---------- TOP LEFT BLOCK ----------
let leftTopY = 125; // moved down from 80

if (hasValue(invoiceDetails?.OrderReferenceNo)) {
  graphics.drawString(
    (`${localStorage.getItem("SaleInvoiceOrderReferenceNoCaption") || 'ORDER Reference No'}:`).toUpperCase(),
    boldFont,
    null,
    blackBrush,
    buyerLabelX,
    leftTopY - 16
  );

  this.wrapText(
    graphics,
    String(invoiceDetails.OrderReferenceNo || '').toUpperCase(),
    subFont,
    blackBrush,
    buyerLabelX + 90,
    leftTopY - 15,
    buyerValueWidth,
    lineH10
  );
}

if (hasValue(invoiceDetails?.ChallanNo)) {
  graphics.drawString(
    (`${localStorage.getItem("SaleInvoiceChallanNoCaption") || "REFERENCE NO."}:`).toUpperCase(),
    boldFont,
    null,
    blackBrush,
    buyerLabelX,
    leftTopY
  );

  this.wrapText(
    graphics,
    String(invoiceDetails.ChallanNo || '').toUpperCase(),
    subFont,
    blackBrush,
    buyerLabelX + 90,
    leftTopY + 1,
    buyerValueWidth,
    lineH10
  );
}

// ---------- INVOICE ----------
graphics.drawString("FBR INVOICE NO.:", boldFont, null, blackBrush, 10, leftTopY + 15);

graphics.drawString(
  `${String(invoiceDetails.invoiceNo ?? "").toUpperCase()}`,
  subFont,
  null,
  blackBrush,
  100,
  leftTopY + 16
);

// ---------- BUYER block ----------
graphics.drawString("BUYER:", boldFont, null, blackBrush, buyerLabelX, leftTopY + 40);

let buyerY = 185;
buyerY = this.wrapText(
  graphics,
  String(invoiceDetails?.buyerName ?? "").toUpperCase(),
  // subFont,
  subBoldFont,
  blackBrush,
  buyerLabelX,
  buyerY,
  280,
  lineH10
) + lineH10;

buyerY = this.wrapText(
  graphics,
  String(invoiceDetails?.buyerAddress ?? "").toUpperCase(),
  subFont,
  blackBrush,
  buyerLabelX,
  buyerY,
  270,
  lineH10
) + rowGap;

// // Optional rows BEFORE REGION
// buyerY = drawOptionalRow(buyerLabelX, buyerValueX, buyerY, "Contact Person", invoiceDetails?.buyerContactPerson, buyerValueWidth);
// buyerY = drawOptionalRow(buyerLabelX, buyerValueX, buyerY, "Contact No.",     invoiceDetails?.buyerContactNumber, buyerValueWidth);
// buyerY = drawOptionalRow(buyerLabelX, buyerValueX, buyerY, "STRN",            invoiceDetails?.buyerSTRN, buyerValueWidth);
// buyerY = drawOptionalRow(buyerLabelX, buyerValueX, buyerY, "CNIC No.",        invoiceDetails?.buyerCNIC, buyerValueWidth);

// ---------- SELLER block ----------
graphics.drawString("SELLER:", boldFont, null, blackBrush, sellerLabelX, 160);

let sellerY = 180;
sellerY = this.wrapText(
  graphics,
  String(invoiceDetails?.sellerName ?? "").toUpperCase(),
  // subFont,
  subBoldFont,
  blackBrush,
  sellerLabelX,
  sellerY,
  200,
  lineH10
) + lineH10;

sellerY = this.wrapText(
  graphics,
  String(invoiceDetails?.sellerAddress ?? "").toUpperCase(),
  subFont,
  blackBrush,
  sellerLabelX,
  sellerY,
  200,
  lineH10
) + rowGap;

// // Optional rows BEFORE REGION
// sellerY = drawOptionalRow(sellerLabelX, sellerValueX, sellerY, "Contact Person", invoiceDetails?.sellerContactPerson, sellerValueWidth);
// sellerY = drawOptionalRow(sellerLabelX, sellerValueX, sellerY, "Contact No.",     invoiceDetails?.sellerContactNumber, sellerValueWidth);
// sellerY = drawOptionalRow(sellerLabelX, sellerValueX, sellerY, "STRN",            invoiceDetails?.sellerSTRN, sellerValueWidth);
// sellerY = drawOptionalRow(sellerLabelX, sellerValueX, sellerY, "CNIC No.",        invoiceDetails?.sellerCNIC, sellerValueWidth);

// ---------- Align REGION/NTN/TYPE/SALE TYPE to the lower of both sides ----------
// let commonY = Math.max(buyerY, sellerY);
// buyerY = commonY;
// sellerY = commonY;
// After buyerAddress + sellerAddress blocks (jab buyerY & sellerY ready hon)
let commonY = Math.max(buyerY, sellerY);
buyerY = sellerY = commonY;

// Optional rows (row-level OR)
commonY = drawOptionalRowPair(
  commonY,
  "CONTACT PERSON",
  invoiceDetails?.buyerContactPerson,
  invoiceDetails?.sellerContactPerson
);

commonY = drawOptionalRowPair(
  commonY,
  "CONTACT NO.",
  invoiceDetails?.buyerContactNumber,
  invoiceDetails?.sellerContactNumber
);

commonY = drawOptionalRowPair(
  commonY,
  "STRN",
  invoiceDetails?.buyerSTRN,
  invoiceDetails?.sellerSTRN
);

commonY = drawOptionalRowPair(
  commonY,
  "CNIC NO.",
  invoiceDetails?.buyerCNIC,
  invoiceDetails?.sellerCNIC
);

buyerY = sellerY = commonY; // keep both aligned for REGION/NTN/TYPE etc

// BUYER mandatory rows
graphics.drawString("REGION:", boldFont, null, blackBrush, buyerLabelX, buyerY);
graphics.drawString(String(invoiceDetails?.buyerRegion ?? "").toUpperCase(), subFont, null, blackBrush, buyerValueX, buyerY + 1);
buyerY += rowGap;

graphics.drawString("NTN:", boldFont, null, blackBrush, buyerLabelX, buyerY);
graphics.drawString(String(invoiceDetails?.buyerNTN ?? "").toUpperCase(), subFont, null, blackBrush, buyerValueX, buyerY + 1);
buyerY += rowGap;

graphics.drawString("TYPE:", boldFont, null, blackBrush, buyerLabelX, buyerY);
graphics.drawString(String(invoiceDetails?.buyerType ?? "").toUpperCase(), subFont, null, blackBrush, buyerValueX, buyerY + 1);
buyerY += rowGap;

graphics.drawString("SALE TYPE:", boldFont, null, blackBrush, buyerLabelX, buyerY);
graphics.drawString(String(invoiceDetails?.saleType ?? "").toUpperCase(), subFont, null, blackBrush, buyerValueX, buyerY + 1);
buyerY += rowGap;

// SELLER mandatory rows
graphics.drawString("REGION:", boldFont, null, blackBrush, sellerLabelX, sellerY);
graphics.drawString(String(invoiceDetails?.sellerRegion ?? "").toUpperCase(), subFont, null, blackBrush, sellerValueX, sellerY + 1);
sellerY += rowGap;

graphics.drawString("NTN:", boldFont, null, blackBrush, sellerLabelX, sellerY);
// graphics.drawString(String(invoiceDetails?.sellerNTN ?? "").toUpperCase(), subFont, null, blackBrush, sellerValueX, sellerY + 1);
graphics.drawString(String(
  invoiceDetails?.sellerNTNCNICReferenceNo &&
  invoiceDetails.sellerNTNCNICReferenceNo.length >= 7
    ? invoiceDetails.sellerNTNCNICReferenceNo
    : invoiceDetails?.sellerNTN ?? "").toUpperCase(), subFont, null, blackBrush, sellerValueX, sellerY + 1);
sellerY += rowGap;

graphics.drawString("TYPE:", boldFont, null, blackBrush, sellerLabelX, sellerY);
graphics.drawString("REGISTERED", subFont, null, blackBrush, sellerValueX, sellerY + 1);
sellerY += rowGap;

// ---------- Use this to place table automatically below header blocks ----------
const tableStartY = Math.max(180, Math.max(buyerY, sellerY) + 5);

    // graphics.drawString(`Type:`, boldFont, null, blackBrush, 350, 155);
    // graphics.drawString(`${invoiceDetails.sellerType}`, subFont, null, blackBrush, 380, 155);
  
    // ===== Table =====
//     const pdfGrid = new PdfGrid();
//     pdfGrid.columns.add(13);
//   // Set column widths
// pdfGrid.columns.getColumn(0).width = 25;   // SR No.
// pdfGrid.columns.getColumn(1).width = 50;   // SR No.
// pdfGrid.columns.getColumn(2).width = 55;  // Description
// pdfGrid.columns.getColumn(3).width = 45;   // HS Code
// pdfGrid.columns.getColumn(4).width = 45;   // Quantity
// pdfGrid.columns.getColumn(5).width = 35;   // Rate
// pdfGrid.columns.getColumn(6).width = 65;   // Amount
// pdfGrid.columns.getColumn(7).width = 35;   // Sales Tax
// pdfGrid.columns.getColumn(8).width = 35;   // Extra Tax
// pdfGrid.columns.getColumn(9).width = 40;   // Further Tax
// pdfGrid.columns.getColumn(10).width = 40;   // FED
// pdfGrid.columns.getColumn(11).width = 45;  // Discount
// pdfGrid.columns.getColumn(12).width = 60;  // Total

//     // Header row
//     const header = pdfGrid.headers.add(1)[0];
//     const headers = [
//       "SR No.","Invoice Number (Detail)", "Document Description", "HS Code", "Quantity", "Rate", "Value of Sales Excl ST",
//       "Sales Tax", "Extra Tax", "Further Tax", "FED Payable", "Discount", "Total Value"
//     ];
//     // headers.forEach((h, i) => {
//     //   header.cells.getCell(i).value = h;
//     //   header.cells.getCell(i).style.font = boldFont;
//     // });

//     const headersboldFont = new PdfStandardFont(PdfFontFamily.Helvetica, 7, PdfFontStyle.Bold);
//     headers.forEach((h, i) => { 
//       header.cells.getCell(i).value = h;
//       header.cells.getCell(i).style.font = headersboldFont;
//       header.cells.getCell(i).style.stringFormat = new PdfStringFormat(PdfTextAlignment.Center);
    
//       // Apply header background + font color
//       header.cells.getCell(i).style.backgroundBrush = new PdfSolidBrush(new PdfColor(0, 102, 128)); // teal blue
//       header.cells.getCell(i).style.textBrush = new PdfSolidBrush(new PdfColor(255, 255, 255));    // white text
//     });
  
//     // Data rows
//     invoiceItems.forEach((item,i) => {
//       const row = pdfGrid.rows.addRow();
//       row.cells.getCell(0).value = item.srNo.toString();
//       row.cells.getCell(1).value = item.FBRSaleInvoiceDetailNo;
//       row.cells.getCell(2).value = item.description;
//       row.cells.getCell(3).value = item.hsCode;
//       // row.cells.getCell(4).value = item.quantity.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//       row.cells.getCell(4).value =
//   `${item.quantity.toLocaleString('en-US', {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2
//   })}\n${item.uoM}`;
//       row.cells.getCell(5).value = item.rate;
//       row.cells.getCell(6).value = item.amount.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });;
//       row.cells.getCell(7).value = item.salesTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });;
//       row.cells.getCell(8).value = item.extraTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });;
//       row.cells.getCell(9).value = item.furtherTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });;
//       row.cells.getCell(10).value = item.fed.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });;
//       row.cells.getCell(11).value = item.discount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });;
//       row.cells.getCell(12).value = item.totalInclTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });;
      
//       for (let c = 0; c < row.cells.count; c++) {
//         row.cells.getCell(c).stringFormat = new PdfStringFormat(PdfTextAlignment.Center);
//       }
//     });
  
//     pdfGrid.style.font = new PdfStandardFont(PdfFontFamily.Helvetica, 7);

//     pdfGrid.style.cellPadding.all = 3;
//     // pdfGrid.draw(page, { x: 0, y: 180 });
//     const layoutResult = pdfGrid.draw(page, { x: 0, y: 180 });
 
const pdfGrid = new PdfGrid();

const headersboldFont = new PdfStandardFont(PdfFontFamily.Helvetica, 7, PdfFontStyle.Bold);
const bodyFont = new PdfStandardFont(PdfFontFamily.Helvetica, 7);

// Reusable header style function
const styleHeaderCell = (cell) => {
  cell.style.font = headersboldFont;
  cell.style.stringFormat = new PdfStringFormat(PdfTextAlignment.Center);
  cell.style.backgroundBrush = new PdfSolidBrush(new PdfColor(0, 102, 128)); // teal blue
  cell.style.textBrush = new PdfSolidBrush(new PdfColor(255, 255, 255));     // white text
};

// ----------------------------
// CASE A: 3rd Schedule Goods
// 11 columns (remove ExtraTax, FED, Discount; add Fixed/Notified)
// Column order keeps your structure and places NEW column where ExtraTax was
// ----------------------------

const PAGE_PADDING = 0;
// const pageWidth = page.getClientSize().width;
const usableWidth = pageWidth - PAGE_PADDING * 2;

const thirdScheduleColumns = [
  { key: "srNo", label: "Sr No.", min: 18 },
  { key: "FBRSaleInvoiceDetailNo", label: "Invoice Number (Detail)", min: 70 },
  { key: "description", label: "Document Description", min: 110 },
  // { key: "SaleProductDescription", label: "Sale Product Description", min: 50 ,visible: localStorage.getItem("ShowSaleDetailInSaleInvoice") == 'true'},
  { key: "SaleQuantity", label: "Sale Quantity", min: 35 ,visible: localStorage.getItem("ShowSaleDetailInSaleInvoice") == 'true'},
  { key: "SaleRate", label: "Sale Rate", min: 35 ,visible: localStorage.getItem("ShowSaleDetailInSaleInvoice") == 'true'},
  // { key: "SaleUnitOfMeasurement", label: "Sale UOM", min: 35 ,visible: localStorage.getItem("ShowSaleDetailInSaleInvoice") == 'true'},
  { key: "hsCode", label: "HS Code", min: 40 },
  { key: "quantity", label: "Quantity", min: 35 },
  { key: "rate", label: "Rate", min: 25 },
  { key: "amount", label: "Value of Sales Excl ST", min: 45, visible: invoiceDetails.amountIsVisible },
  { key: "salesTax", label: "Sales Tax", min: 45, visible: invoiceDetails.salesTaxsVisible },
  {
    key: "fixedNotifiedValueOrRetailPrice",
    label: "FIXED / NOTIFIED VALUE OR RETAIL PRICE",
    min: 65,
    visible: invoiceDetails.fixedNotifiedValueOrRetailPrice !== 0
  },
  { key: "furtherTax", label: "Further Tax", min: 42, visible: invoiceDetails.furtherTaxsVisible },
  { key: "totalInclTax", label: "Total Value", min: 55, visible: invoiceDetails.totalInclTaxsVisible }
];

const normalColumns = [
  { key: "srNo", label: "Sr No.", min: 18 },
  { key: "FBRSaleInvoiceDetailNo", label: "Invoice Number (Detail)", min: 70 },
  { key: "description", label: "Document Description", min: 110 },
  // { key: "SaleProductDescription", label: "Sale Product Description", min: 55 ,visible: localStorage.getItem("ShowSaleDetailInSaleInvoice") == 'true'},
  { key: "SaleQuantity", label: "Sale Quantity", min: 35 ,visible: localStorage.getItem("ShowSaleDetailInSaleInvoice") == 'true'},
  { key: "SaleRate", label: "Sale Rate", min: 35 ,visible: localStorage.getItem("ShowSaleDetailInSaleInvoice") == 'true'},
  // { key: "SaleUnitOfMeasurement", label: "Sale UOM", min: 35 ,visible: localStorage.getItem("ShowSaleDetailInSaleInvoice") == 'true'},
  { key: "hsCode", label: "HS Code", min: 40 },
  { key: "quantity", label: "Quantity", min: 45 },
  { key: "rate", label: "Rate", min: 25 },
  { key: "amount", label: "Value of Sales Excl ST", min: 45, visible: invoiceDetails.amountIsVisible },
  { key: "salesTax", label: "Sales Tax", min: 45, visible: invoiceDetails.salesTaxsVisible },
  { key: "extraTax", label: "Extra Tax", min: 40, visible: invoiceDetails.extraTaxsVisible },
  { key: "furtherTax", label: "Further Tax", min: 35, visible: invoiceDetails.furtherTaxsVisible },
  { key: "fed", label: "FED Payable", min: 40, visible: invoiceDetails.fedsVisible },
  { key: "discount", label: "Discount", min: 40, visible: invoiceDetails.discountsVisible },
  { key: "totalInclTax", label: "Total Value", min: 55, visible: invoiceDetails.totalInclTaxsVisible }
];

const saleTypeNormalized = String(invoiceDetails?.saleType ?? "")
  .replace(/\s+/g, "")     // remove ALL spaces
  .toLowerCase();

const isThirdScheduleGoods = saleTypeNormalized === "3rdschedulegoods";

const baseColumns = isThirdScheduleGoods ? thirdScheduleColumns : normalColumns;
// const baseColumns =  thirdScheduleColumns;

const visibleColumns = baseColumns.filter(
  col => col.visible !== false
);

// const totalMinWidth = visibleColumns.reduce((s, c) => s + c.min, 0);
// const scale = usableWidth / totalMinWidth;

// visibleColumns.forEach(c => {
//   c.width = Math.max(c.min * scale, c.min);
// });


// STEP 1
// Visible columns


// STEP 2
// Sab columns ki minimum width total
const totalMinWidth = visibleColumns.reduce(
  (sum, col) => sum + col.min,
  0
);

// STEP 3
// Remaining width after minimum widths
const remainingWidth = usableWidth - totalMinWidth;

// STEP 4
// Extra width equally divide
const extraWidthPerColumn =
  remainingWidth > 0
    ? remainingWidth / visibleColumns.length
    : 0;

// STEP 5
// Final width assign
visibleColumns.forEach(col => {
  col.width = col.min + extraWidthPerColumn;
});
pdfGrid.columns.add(visibleColumns.length);

visibleColumns.forEach((col, i) => {
  pdfGrid.columns.getColumn(i).width = col.width;
});







const header = pdfGrid.headers.add(1)[0];

visibleColumns.forEach((col, i) => {
  const cell = header.cells.getCell(i);
  cell.value = col.label;
  styleHeaderCell(cell);
});





invoiceItems.forEach(item => {
  const row = pdfGrid.rows.addRow();

  visibleColumns.forEach((col, i) => {
    let value = item[col.key] ?? "";

    if (["amount", "salesTax", "extraTax", "furtherTax", "fed", "discount", "totalInclTax","SaleQuantity","SaleRate"].includes(col.key)) {
      value = Number(value).toLocaleString("en-US", { minimumFractionDigits: 2 });
    }

    if (col.key === "quantity") {
      value = `${Number(item.quantity ?? 0).toLocaleString("en-US", {
        minimumFractionDigits: 2
      })}\n${String(item.uoM ?? "").toUpperCase()}`;
    }
   if(localStorage.getItem("ShowSaleDetailInSaleInvoice") == 'true'){
    if (col.key === "description") {
      value = `${item.description ?? ""}\n${String(item.SaleProductDescription ?? "").toUpperCase()}`;
    }
    if (col.key === "SaleRate") {
  
      const numericValue = Number(String(value).replace(/,/g, ''));

value = `${numericValue.toLocaleString("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}\n${String(item.SaleUnitOfMeasurement ?? "").toUpperCase()}`;
      // value = `${Number(value).toLocaleString("en-US", { minimumFractionDigits: 2 })}\n${String(item.SaleUnitOfMeasurement ?? "").toUpperCase()}`;
    }

  }
    row.cells.getCell(i).value = String(value);
    row.cells.getCell(i).stringFormat = new PdfStringFormat(PdfTextAlignment.Center);
  });
});





// if (isThirdScheduleGoods) {
//   pdfGrid.columns.add(11);

//   // widths (adjust as you like; heading is long so give it more)
//   pdfGrid.columns.getColumn(0).width = 25;  // SR No.
//   pdfGrid.columns.getColumn(1).width = 50;  // Invoice Number (Detail)
//   pdfGrid.columns.getColumn(2).width = 55;  // Description
//   pdfGrid.columns.getColumn(3).width = 45;  // HS Code
//   pdfGrid.columns.getColumn(4).width = 45;  // Quantity
//   pdfGrid.columns.getColumn(5).width = 35;  // Rate
//   pdfGrid.columns.getColumn(6).width = 65;  // Value of Sales Excl ST
//   pdfGrid.columns.getColumn(7).width = 55;  // Sales Tax
//   pdfGrid.columns.getColumn(8).width = 80;  // FIXED/NOTIFIED VALUE OR RETAIL PRICE (NEW)
//   pdfGrid.columns.getColumn(9).width = 50;  // Further Tax
//   pdfGrid.columns.getColumn(10).width = 60; // Total Value

//   const header = pdfGrid.headers.add(1)[0];
//   const headers = [
//     "SR No.",
//     "Invoice Number (Detail)",
//     "Document Description",
//     "HS Code",
//     "Quantity",
//     "Rate",
//     "Value of Sales Excl ST",
//     "Sales Tax",
//     "FIXED/NOTIFIED VALUE OR RETAIL PRICE",
//     "Further Tax",
//     "Total Value",
//   ];

//   headers.forEach((h, i) => {
//     const cell = header.cells.getCell(i);
//     cell.value = h;
//     styleHeaderCell(cell);
//   });

//   // Data rows
//   invoiceItems.forEach((item) => {
//     const row = pdfGrid.rows.addRow();

//     row.cells.getCell(0).value = String(item.srNo ?? "");
//     row.cells.getCell(1).value = String(item.FBRSaleInvoiceDetailNo ?? "");
//     row.cells.getCell(2).value = String(item.description ?? "");
//     row.cells.getCell(3).value = String(item.hsCode ?? "");

//     row.cells.getCell(4).value =
//       `${Number(item.quantity ?? 0).toLocaleString("en-US", {
//         minimumFractionDigits: 2,
//         maximumFractionDigits: 2,
//       })}\n${String(item.uoM ?? "").toUpperCase()}`;

//     row.cells.getCell(5).value = String(item.rate ?? "");

//     row.cells.getCell(6).value = Number(item.amount ?? 0).toLocaleString("en-US", {
//       minimumFractionDigits: 0,
//       maximumFractionDigits: 0,
//     });

//     row.cells.getCell(7).value = Number(item.salesTax ?? 0).toLocaleString("en-US", {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     });

//     // NEW column (0 decimals)
//     row.cells.getCell(8).value = Number(item.fixedNotifiedValueOrRetailPrice ?? 0).toLocaleString(
//       "en-US",
//       { minimumFractionDigits: 0, maximumFractionDigits: 0 }
//     );

//     row.cells.getCell(9).value = Number(item.furtherTax ?? 0).toLocaleString("en-US", {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     });

//     row.cells.getCell(10).value = Number(item.totalInclTax ?? 0).toLocaleString("en-US", {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     });

//     for (let c = 0; c < row.cells.count; c++) {
//       row.cells.getCell(c).stringFormat = new PdfStringFormat(PdfTextAlignment.Center);
//     }
//   });

// } else {
//   // ----------------------------
//   // CASE B: Normal table (your existing 13 columns)
//   // ----------------------------
//   pdfGrid.columns.add(13);

//   pdfGrid.columns.getColumn(0).width = 25;
//   pdfGrid.columns.getColumn(1).width = 50;
//   pdfGrid.columns.getColumn(2).width = 60;
//   pdfGrid.columns.getColumn(3).width = 45;
//   pdfGrid.columns.getColumn(4).width = 45;
//   pdfGrid.columns.getColumn(5).width = 35;
//   pdfGrid.columns.getColumn(6).width = 65;
//   pdfGrid.columns.getColumn(7).width = 45;
//   pdfGrid.columns.getColumn(8).width = 40;
//   pdfGrid.columns.getColumn(9).width = 35;
//   pdfGrid.columns.getColumn(10).width = 40;
//   pdfGrid.columns.getColumn(11).width = 40;
//   pdfGrid.columns.getColumn(12).width = 55;

//   const header = pdfGrid.headers.add(1)[0];
//   const headers = [
//     "SR No.",
//     "Invoice Number (Detail)",
//     "Document Description",
//     "HS Code",
//     "Quantity",
//     "Rate",
//     "Value of Sales Excl ST",
//     "Sales Tax",
//     "Extra Tax",
//     "Further Tax",
//     "FED Payable",
//     "Discount",
//     "Total Value",
//   ];

//   headers.forEach((h, i) => {
//     const cell = header.cells.getCell(i);
//     cell.value = h;
//     styleHeaderCell(cell);
//   });

//   invoiceItems.forEach((item) => {
//     const row = pdfGrid.rows.addRow();

//     row.cells.getCell(0).value = String(item.srNo ?? "");
//     row.cells.getCell(1).value = String(item.FBRSaleInvoiceDetailNo ?? "");
//     row.cells.getCell(2).value = String(item.description ?? "").toUpperCase();
//     row.cells.getCell(3).value = String(item.hsCode ?? "");

//     row.cells.getCell(4).value =
//       `${Number(item.quantity ?? 0).toLocaleString("en-US", {
//         minimumFractionDigits: 2,
//         maximumFractionDigits: 2,
//       })}\n${String(item.uoM ?? "").toUpperCase()}`;

//     row.cells.getCell(5).value = String(item.rate ?? "");

//     row.cells.getCell(6).value = Number(item.amount ?? 0).toLocaleString("en-US", {
//       minimumFractionDigits: 0,
//       maximumFractionDigits: 0,
//     });

//     row.cells.getCell(7).value = Number(item.salesTax ?? 0).toLocaleString("en-US", {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     });

//     row.cells.getCell(8).value = Number(item.extraTax ?? 0).toLocaleString("en-US", {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     });

//     row.cells.getCell(9).value = Number(item.furtherTax ?? 0).toLocaleString("en-US", {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     });

//     row.cells.getCell(10).value = Number(item.fed ?? 0).toLocaleString("en-US", {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     });

//     row.cells.getCell(11).value = Number(item.discount ?? 0).toLocaleString("en-US", {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     });

//     row.cells.getCell(12).value = Number(item.totalInclTax ?? 0).toLocaleString("en-US", {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     });

//     for (let c = 0; c < row.cells.count; c++) {
//       row.cells.getCell(c).stringFormat = new PdfStringFormat(PdfTextAlignment.Center);
//     }
//   });
// }

// shared styling
pdfGrid.style.font = bodyFont;
pdfGrid.style.cellPadding.all = 3;

// draw
// const layoutResult = pdfGrid.draw(page, { x: 0, y: 180 });



// Draw grid
const layoutFormat = new PdfLayoutFormat();
layoutFormat.layout = PdfLayoutType.Paginate;

const layoutResult = pdfGrid.draw(page, { x: 0, y: tableStartY }, layoutFormat);

let currentPage = layoutResult.page;
 graphics = currentPage.graphics;

let currentY = layoutResult.bounds.y + layoutResult.bounds.height + 20;


const pageHeight = currentPage.getClientSize().height;

if (currentY + 180 > pageHeight) {
  currentPage = document.pages.add();
  graphics = currentPage.graphics;
  currentY = 20;
}
// Remarks
// let remarksY = lastBounds.y + lastBounds.height + 20;

    // const layoutResult = pdfGrid.draw(page, { x: 0, y: tableStartY });
    
    
        // ===== Totals =====
        console.log('layout result',layoutResult)
        let CalculateGap = invoiceItems?.length * 20
        // let yBase = 310 + CalculateGap;
        // let yBase = lastBounds.y + lastBounds.height + 25;
    
        // After drawing PdfGrid
    
    
    
    //     let xPos = page.getClientSize().width - 250;  // right aligned box
    // let yPos = lastBounds.height + lastBounds.y + 20; 
    let xPos = currentPage.getClientSize().width - 250;
let yPos = currentY;

    let boxWidth = 220;
    let boxHeight = 140;
    
    graphics.drawRectangle(new PdfPen(PdfColor.black, 1), xPos, yPos, boxWidth, boxHeight);
    
    let lineHeight = 14;
    let padding = 5;
    currentY += 110; // box ke baad niche shift
    // Function to measure and right-align text
    function drawRightAligned(text, yOffset, font) {
        let textWidth = font.measureString(text).width;
        let drawX = xPos + boxWidth - padding - textWidth; // right edge inside box
        let drawY = yPos + yOffset;
        graphics.drawString(text, font, null, PdfBrushes.black, drawX, drawY);
    }
    if(isThirdScheduleGoods){
      drawRightAligned(`Value of Sales Excl ST: ${invoiceDetails.subTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8, subFont);
      drawRightAligned(`FIXED/NOTIFIED VALUE OR RETAIL PRICE: ${invoiceDetails.fixedNotifiedValueOrRetailPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8 + lineHeight * 1, subFont);
      drawRightAligned(`Sales Tax (GST): ${invoiceDetails.salesTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8 + lineHeight * 2, subFont);
      drawRightAligned(`Further Tax: ${invoiceDetails.furtherTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8 + lineHeight * 3, subFont);
      if(invoiceDetails.ShowAdvanceIncomeTax  == true){
        drawRightAligned(`Advance Tax U/S  ${invoiceDetails.AdvanceIncomeTaxDescription} @${invoiceDetails.AdvanceIncomeTaxPercent.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}% : ${invoiceDetails.TotalAdvanceIncomeTaxAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8 + lineHeight * 6, subFont);
      }
    }
    else{
    drawRightAligned(`Value of Sales Excl ST: ${invoiceDetails.subTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8, subFont);
    drawRightAligned(`Sales Tax (GST): ${invoiceDetails.salesTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8 + lineHeight * 1, subFont);
    drawRightAligned(`Further Tax: ${invoiceDetails.furtherTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8 + lineHeight * 2, subFont);
    drawRightAligned(`Extra Tax: ${invoiceDetails.extraTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8 + lineHeight * 3, subFont);
    drawRightAligned(`FED Payable: ${invoiceDetails.fedPayable.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8 + lineHeight * 4, subFont);
    drawRightAligned(`Discount: ${invoiceDetails.discount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8 + lineHeight * 5, subFont);
    if(invoiceDetails.ShowAdvanceIncomeTax  == true){
    drawRightAligned(`Advance Tax U/S  ${invoiceDetails.AdvanceIncomeTaxDescription} @${invoiceDetails.AdvanceIncomeTaxPercent.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}% : ${invoiceDetails.TotalAdvanceIncomeTaxAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8 + lineHeight * 6, subFont);
    }
    }
    drawRightAligned(
      `Grand Total Value : Rs. ${invoiceDetails.grandTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
      9 + lineHeight * 7,
      boldFont
    );
    
        // ===== Amount in Words =====
        // graphics.drawString("Total in words:", boldFont, null, blackBrush, 10, yBase);
        // graphics.drawString(invoiceDetails.grandTotalInWords, boldFont, null, blackBrush, 10, yBase + 15);
      
        // graphics.drawString("Total in words:", boldFont, null, blackBrush, 10, yBase);
        // this.wrapText(graphics, invoiceDetails.grandTotalInWords, boldFont, blackBrush, 10, yBase + 15, 300, 15);
        
    
        graphics.drawString("Total in words:", boldFont, null, blackBrush, 10, yPos);

        this.wrapText(
          graphics,
          String(invoiceDetails?.grandTotalInWords ?? ""),
          boldFont,
          blackBrush,
          10,
          yPos + 15,
          300,
          15
        );
        
        currentY += 50;

        if (currentY + 120 > pageHeight) {
  currentPage = document.pages.add();
  graphics = currentPage.graphics;
  currentY = 20;
}
        
    
        //  // ===== IMAGE (Base64 PNG) =====
        const blobToBase64 = (blob) => {
          return new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result.split(',')[1]); // Extract only Base64 data
              reader.onerror = reject;
              reader.readAsDataURL(blob);
          });
        };
      
      
    
          const url = URL.createObjectURL(blob);
    
          const response = await fetch(url);
          if (!response.ok) throw new Error(`Failed to fetch image: ${response.statusText}`);
        
          const imageBlob = await response.blob();
          const imageBase64 = await blobToBase64(imageBlob);
        
         // Create PdfBitmap from Base64
         const image = new PdfBitmap(imageBase64);
           
         // Draw the image on the PDF
        //  let xImgPos = page.getClientSize().width - 115;  // right aligned box
        //   let yImgPos = lastBounds.height + lastBounds.y + 170; 
          let xImgPos = currentPage.getClientSize().width;

         graphics.drawImage(image, xImgPos - 115, currentY,96 ,96 ); // Adjust x, y, width, height as needed
          
    
    
         // ==== FBR IMAGE DRAW ====
         const FBRIMGresponse = await fetch('/fbr-img.jpg');
         if (!FBRIMGresponse.ok) throw new Error(`Failed to fetch image: ${response.statusText}`);
         
                 const FBRimageBlob = await FBRIMGresponse.blob();
                 const FBRimageBase64 = await blobToBase64(FBRimageBlob);
         
                // Create PdfBitmap from Base64
                const FBRimage = new PdfBitmap(FBRimageBase64);
                  
                // Draw the FBRimage on the PDF
                graphics.drawImage(FBRimage, 40, currentY,50 ,50 ); // Adjust x, y, width, height as needed

                currentY += 110;
                graphics.drawString(
                    "THIS IS A SYSTEM GENERATED DIGITAL INVOICE. NO SIGNATURE REQUIRED",
                    subFont,
                    null,
                    blackBrush,
                    pageWidth / 2 - 150,
                    currentY
                  );
                  currentY += 20;

                  // graphics.drawString(
                  //   invoiceDetails.SellerRemarks,
                  //   boldFonts,
                  //   null,
                  //   blackBrush,
                  //   pageWidth / 2 - 40,
                  //   currentY
                  // );

                   // OPTION 1: Just Center (One Line Fix)
// const textWidth = boldFonts.measureString(
//   invoiceDetails.SellerRemarks
  
// ).width;

// graphics.drawString(
//   invoiceDetails.SellerRemarks,
//   boldFonts,
//   null,
//   blackBrush,
//   pageWidth / 2 - textWidth / 2,  // Changed from: pageWidth / 2 - 40
//   currentY
// );


const remarks = invoiceDetails.SellerRemarks;

const format = new PdfStringFormat();
format.alignment = PdfTextAlignment.Center;
format.lineAlignment = PdfVerticalAlignment.Top;
format.wordWrap = PdfWordWrapType.Word;

const maxWidth = 350; 

graphics.drawString(
  String(remarks).toUpperCase(),
  boldFonts,
  null,
  blackBrush,
  pageWidth / 2 - maxWidth / 2,
  currentY,
  maxWidth,
  100, // enough height for multiple lines
  format
);

currentY += 20;

//                   const sellerNameText = String(invoiceDetails.SellerRemarks ?? '').toUpperCase();
// const sellerNameMaxWidth = pageWidth - 220;
// const sellerNameWords = sellerNameText.split(' ');
// const sellerNameLines = [];
// let sellerNameCurLine = '';

// for (const word of sellerNameWords) {
//   const testLine  = sellerNameCurLine ? `${sellerNameCurLine} ${word}` : word;
//   const testWidth = boldFonts.measureString(testLine).width;
//   if (testWidth > sellerNameMaxWidth && sellerNameCurLine) {
//     sellerNameLines.push(sellerNameCurLine);
//     sellerNameCurLine = word;
//   } else {
//     sellerNameCurLine = testLine;
//   }
// }
// if (sellerNameCurLine) sellerNameLines.push(sellerNameCurLine);

// const sellerNameLineHeight = 18;
//  currentY += 10;
// sellerNameLines.forEach((line) => {
//   const lineW = boldFonts.measureString(line).width;
//   const lineX = (pageWidth - lineW) / 2;
//   graphics.drawString(line, boldFonts, null, blackBrush, lineX, currentY);
//   currentY += sellerNameLineHeight;
// });

                
                // ===== Save or Return Blob =====
        if (type === 'save') {
          const pdfBlob = await document.save();
          document.destroy();
          return pdfBlob;
        } else {
          document.save("SalesTaxInvoice.pdf");
          document.destroy();
        }
      }



  // ===============================  Sales Tax Invoice - Format E (ARS Industry Style) ==================================
  async SalesTaxInvoiceReportE(invoiceDetails, invoiceItems, blob, type = 'download') {
    const document = new PdfDocument();

    // Page settings
    document.pageSettings.margins.all = 10;
    document.pageSettings.margins.bottom = 5;
    document.pageSettings.size = PdfPageSize.a4;

    const page = document.pages.add();
    const graphics = page.graphics;
    const pageWidth = page.getClientSize().width;

    // ===== FONTS =====
    const companyNameFont  = new PdfStandardFont(PdfFontFamily.Helvetica, 20, PdfFontStyle.Bold);
    const invoiceTitleFont = new PdfStandardFont(PdfFontFamily.Helvetica, 14, PdfFontStyle.Bold);
    const boldFont         = new PdfStandardFont(PdfFontFamily.Helvetica, 9,  PdfFontStyle.Bold);
    const boldFonts        = new PdfStandardFont(PdfFontFamily.Helvetica, 10, PdfFontStyle.Bold);
    const subFont          = new PdfStandardFont(PdfFontFamily.Helvetica, 8);
    const subBoldFont      = new PdfStandardFont(PdfFontFamily.Helvetica, 8,  PdfFontStyle.Bold);
    const smallFont        = new PdfStandardFont(PdfFontFamily.Helvetica, 7);
    const headersboldFont  = new PdfStandardFont(PdfFontFamily.Helvetica, 7,  PdfFontStyle.Bold);
    const bodyFont         = new PdfStandardFont(PdfFontFamily.Helvetica, 7);

    // ===== BRUSHES & PENS =====
    const blackBrush = new PdfSolidBrush(new PdfColor(0, 0, 0));
    const blackPen   = new PdfPen(new PdfColor(0, 0, 0), 1);
    const thinPen    = new PdfPen(new PdfColor(0, 0, 0), 0.5);

    // ==========================================
    // SECTION 1 — COMPANY HEADER
    // ==========================================

    // --- LOGO (top-left) ---
    if (invoiceDetails.sellerLogo && invoiceDetails.sellerLogo !== '') {
      const blobToBase641 = (b) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result.split(',')[1]);
        reader.onerror = reject;
        reader.readAsDataURL(b);
      });
      const url1 = URL.createObjectURL(invoiceDetails.sellerLogo);
      const response1 = await fetch(url1);
      if (!response1.ok) throw new Error(`Failed to fetch logo: ${response1.statusText}`);
      const imageBlob1   = await response1.blob();
      const imageBase641 = await blobToBase641(imageBlob1);
      // const logoImage    = new PdfBitmap(imageBase641);




  

const imageBase64s = new PdfBitmap(imageBase641);


// Get original dimensions
const originalWidth = imageBase64s.width;
const originalHeight = imageBase64s.height;

// Max allowed size
const maxWidth = 110;
const maxHeight = 110;

// Calculate scale ratio
const widthRatio = maxWidth / originalWidth;
const heightRatio = maxHeight / originalHeight;
const scale = Math.min(widthRatio, heightRatio);

// New scaled size
const newWidth = originalWidth * scale;
const newHeight = originalHeight * scale;

// Draw image centered (optional)
const x = 10;
const y = 10;

graphics.drawImage(imageBase64s, x, y, newWidth, newHeight)

      // graphics.drawImage(logoImage, 10, 8, 75, 75);
    }

    // --- SELLER NAME centered ---
// --- SELLER NAME centered + WRAPPED (no underline) ---
const sellerNameText = String(invoiceDetails.sellerName ?? '').toUpperCase();
const sellerNameMaxWidth = pageWidth - 220;
const sellerNameWords = sellerNameText.split(' ');
const sellerNameLines = [];
let sellerNameCurLine = '';

for (const word of sellerNameWords) {
  const testLine  = sellerNameCurLine ? `${sellerNameCurLine} ${word}` : word;
  const testWidth = companyNameFont.measureString(testLine).width;
  if (testWidth > sellerNameMaxWidth && sellerNameCurLine) {
    sellerNameLines.push(sellerNameCurLine);
    sellerNameCurLine = word;
  } else {
    sellerNameCurLine = testLine;
  }
}
if (sellerNameCurLine) sellerNameLines.push(sellerNameCurLine);

const sellerNameLineHeight = 18;
let sellerNameY = 10;
sellerNameLines.forEach((line) => {
  const lineW = companyNameFont.measureString(line).width;
  const lineX = (pageWidth - lineW) / 2;
  graphics.drawString(line, companyNameFont, null, blackBrush, lineX, sellerNameY);
  sellerNameY += sellerNameLineHeight;
});

// --- SELLER ADDRESS starts after seller name lines ---
let addrY = sellerNameY + 18; // small gap after name
    // const sellerNameText = String(invoiceDetails.sellerName ?? '').toUpperCase();
    // const sellerNameMW   = companyNameFont.measureString(sellerNameText).width;
    // const sellerNameX    = (pageWidth - sellerNameMW) / 2;
    // graphics.drawString(sellerNameText, companyNameFont, null, blackBrush, sellerNameX, 10);

    // --- SELLER ADDRESS centered + underline ---
    // --- SELLER ADDRESS centered + underline (wraps if long) ---
const sellerAddrText  = String(invoiceDetails.sellerAddress ?? '').toUpperCase();
const addrFont        = new PdfStandardFont(PdfFontFamily.Helvetica, 12, PdfFontStyle.Bold);;
const addrLineHeight  = 18;    // gap between wrapped lines
const addrUnderlineGap = 4;   // px below text baseline before underline

// Split into wrapped lines respecting pageWidth with small side margins
const addrMaxWidth = pageWidth - 220;
const addrWords    = sellerAddrText.split(' ');
const addrLines    = [];
let   addrCurLine  = '';

for (const word of addrWords) {
  const testLine  = addrCurLine ? `${addrCurLine} ${word}` : word;
  const testWidth = addrFont.measureString(testLine).width;
  if (testWidth > addrMaxWidth && addrCurLine) {
    addrLines.push(addrCurLine);
    addrCurLine = word;
  } else {
    addrCurLine = testLine;
  }
}
if (addrCurLine) addrLines.push(addrCurLine);

// Draw each line centered with underline below it
// let addrY = ;
addrLines.forEach((line) => {
  const lineW  = addrFont.measureString(line).width;
  const lineX  = (pageWidth - lineW) / 2;
  const fontSz = addrFont.size ?? 10;
  graphics.drawString(line, addrFont, null, blackBrush, lineX, addrY);
  // underline sits just below the text
  const underlineY = addrY + fontSz + addrUnderlineGap;
  graphics.drawLine(thinPen, lineX, underlineY, lineX + lineW, underlineY);
  addrY += addrLineHeight;
});
    // const sellerAddrText = String(invoiceDetails.sellerAddress ?? '').toUpperCase();
    // const sellerAddrMW   = subFont.measureString(sellerAddrText).width;
    // const sellerAddrX    = (pageWidth - sellerAddrMW) / 2;
    // graphics.drawString(sellerAddrText, boldFonts, null, blackBrush, sellerAddrX, 38);
    // graphics.drawLine(thinPen, sellerAddrX, 49, sellerAddrX + sellerAddrMW, 49);

    // ✅ TOP-RIGHT — SELLER STRN / REGION / NTN / TYPE (4 rows, stacked)
    const strnDisplay   = String(
      invoiceDetails.sellerNTNCNICReferenceNo &&
      invoiceDetails.sellerNTNCNICReferenceNo.length >= 7
        ? invoiceDetails.sellerNTNCNICReferenceNo
        : invoiceDetails.sellerNTN ?? ''
    ).toUpperCase();
    const ntnDisplay    = String(invoiceDetails.sellerNTN ?? '').toUpperCase();
    const regionDisplay = String(invoiceDetails.sellerRegion ?? '').toUpperCase();
    const typeDisplay   = 'REGISTERED';

    // right-align all 4 rows — measure longest string to find X anchor
    const sellerInfoLines = [
      { label: 'STRN   :', value: strnDisplay   },
      { label: 'REGION :', value: regionDisplay },
      { label: 'NTN    :', value: ntnDisplay    },
      { label: 'TYPE   :', value: typeDisplay   },
    ];
    
    const infoLineH    = 14;
    let   infoStartY   =  8;
    const infoBlockX   = pageWidth - 100;  // left edge of the whole block
    const infoRightEdge = pageWidth - 5;   // right margin
    
    sellerInfoLines.forEach((line, idx) => {
      const y = infoStartY + idx * infoLineH;
    
      // Label — left-aligned at block start
      graphics.drawString(line.label, subBoldFont, null, blackBrush, infoBlockX, y);
    
      // Value — right-aligned to right edge
      const valueW = subBoldFont.measureString(line.value).width;
      const valueX = infoRightEdge - valueW;
      graphics.drawString(line.value, subBoldFont, null, blackBrush, valueX, y);
    });

    // --- ORIGINAL / DUPLICATE CHECKBOX (only box, no labels per original code) ---
    const cbX     = pageWidth - 110;
    const cbY     = 8;
    const cbCellW = 85;
    const cbCellH = 18;
    // outer rectangle (2 rows)
    // graphics.drawRectangle(thinPen, cbX, cbY, cbCellW, cbCellH * 2);
    // horizontal divider
    // graphics.drawLine(thinPen, cbX, cbY + cbCellH, cbX + cbCellW, cbY + cbCellH);
    // vertical divider (checkbox column)
    const tickColX = cbX + cbCellW - 20;
    // graphics.drawLine(thinPen, tickColX, cbY, tickColX, cbY + cbCellH * 2);
// 
    // ==========================================
    // SECTION 2 — BUYER BOX (left) + INVOICE INFO (right)
    // ==========================================

    const leftColW  = pageWidth * 0.55;
    const rightColX = leftColW + 10;
    let   sectionY  = addrY + 30;

    // ---- LEFT: Buyer heading ----
    graphics.drawString("BUYER'S NAME & ADDRESS:", boldFont, null, blackBrush, 10, sectionY);  // ✅ uppercase

    // ---- LEFT: Buyer box ----
    const boxX = 10;
    const boxY = sectionY + 14;
    const boxW = leftColW - 10;
    const lblX = boxX + 8;
    const valX = boxX + 72;
    const valW = boxW - 82;

    let byY = boxY + 8;

    // Name
    graphics.drawString('NAME:', boldFont, null, blackBrush, lblX, byY);  // ✅ uppercase
    this.wrapText(graphics, String(invoiceDetails.buyerName ?? '').toUpperCase(), subBoldFont, blackBrush, valX, byY, valW, 10);
    byY += 20;

    // Address
    graphics.drawString('ADDRESS:', boldFont, null, blackBrush, lblX, byY);  // ✅ uppercase
    const addrEndY = this.wrapText(graphics, String(invoiceDetails.buyerAddress ?? '').toUpperCase(), subFont, blackBrush, valX, byY, valW, 10);
    byY = addrEndY + 14;
if(invoiceDetails.buyerSTRN){
    // STRN
    const buyerGST = String(invoiceDetails.buyerSTRN ??  '').toUpperCase();  // ✅ uppercase
    graphics.drawString('STRN:', boldFont, null, blackBrush, lblX, byY);
    graphics.drawString(buyerGST, subFont, null, blackBrush, valX, byY);
    byY += 14;
}

    // REGION
    const buyerRegion = String(invoiceDetails.buyerRegion ?? '').toUpperCase();  // ✅ uppercase
    graphics.drawString('REGION:', boldFont, null, blackBrush, lblX, byY);
    graphics.drawString(buyerRegion, subFont, null, blackBrush, valX, byY);
    byY += 14;

    // NTN
    graphics.drawString('NTN:', boldFont, null, blackBrush, lblX, byY);
    graphics.drawString(String(invoiceDetails.buyerNTN ?? '').toUpperCase(), subFont, null, blackBrush, valX, byY);  // ✅ uppercase
    byY += 14;

    // TYPE
    graphics.drawString('TYPE:', boldFont, null, blackBrush, lblX, byY);
    graphics.drawString(String(invoiceDetails.buyerType ?? 'REGISTERED').toUpperCase(), subFont, null, blackBrush, valX, byY);  // ✅ uppercase
    byY += 14;

    // Draw buyer box border
    const boxH = byY - boxY + 4;
    graphics.drawRectangle(thinPen, boxX, boxY, boxW, boxH);

    // ---- RIGHT: "Sales Tax Invoice" heading ----
    const invTitle   = 'SALES TAX INVOICE';  // ✅ uppercase
    const invTitleMW = invoiceTitleFont.measureString(invTitle).width;
    graphics.drawString(invTitle, invoiceTitleFont, null, blackBrush, rightColX, sectionY - 4);
    graphics.drawLine(thinPen, rightColX, sectionY + 12, rightColX + Math.max(invTitleMW, 30), sectionY + 12);

    // ---- RIGHT: Invoice meta rows ----
    let invY    = sectionY + 26;
    const invLblX = rightColX;
    const invValX = rightColX + 85;

    // Helper: draw label + plain value
    const drawBoxedRow = (label, value) => {
      graphics.drawString(label.toUpperCase(), subFont, null, blackBrush, invLblX, invY);  // ✅ uppercase label
      const valStr = String(value ?? '').toUpperCase();  // ✅ uppercase value
      graphics.drawString(valStr, subFont, null, blackBrush, invValX + 2, invY);
      invY += 17;
    };

    drawBoxedRow('INVOICE NO.',   invoiceDetails.invoiceNo ?? '');
    drawBoxedRow('DATE',          moment(invoiceDetails.date).format('DD/MM/YYYY'));
    drawBoxedRow('SOFTWARE ID:',  String(invoiceDetails.SaleInvoiceID ?? '').padStart(4, '0'));
    drawBoxedRow((`${localStorage.getItem("SaleInvoiceOrderReferenceNoCaption")}:` || 'ORDER Reference No :').toUpperCase(), String(invoiceDetails.OrderReferenceNo ?? ''));
    drawBoxedRow((`${localStorage.getItem("SaleInvoiceChallanNoCaption")}:` || "REFERENCE NO.:").toUpperCase(), String(invoiceDetails.ChallanNo ?? ''));
    drawBoxedRow('SALE TYPE:',    String(invoiceDetails.saleType ?? ''));

    // Table Y = below the taller of buyer-box or invoice-meta
    const tableStartY = Math.max(boxY + boxH + 10, invY + 8);

    // ==========================================
    // SECTION 3 — ITEMS GRID  (same logic as SalesTaxInvoiceReport)
    // ==========================================

    const styleHeaderCell = (cell) => {
      cell.style.font = headersboldFont;
      cell.style.stringFormat = new PdfStringFormat(PdfTextAlignment.Center);
      cell.style.backgroundBrush = new PdfSolidBrush(new PdfColor(0, 102, 128));
      cell.style.textBrush       = new PdfSolidBrush(new PdfColor(255, 255, 255));
    };

    const usableWidth = pageWidth;

    const thirdScheduleColumns = [
      { key: 'srNo',                            label: 'SR NO.',                                  min: 18 },
      { key: 'FBRSaleInvoiceDetailNo',          label: 'INVOICE NUMBER (DETAIL)',                 min: 70 },
      { key: 'description',                     label: 'DOCUMENT DESCRIPTION',                    min: 105 },
      // { key: "SaleProductDescription", label: "Sale Product Description", min: 55 ,visible: localStorage.getItem("ShowSaleDetailInSaleInvoice") == 'true'},
  { key: "SaleQuantity", label: "Sale Quantity", min: 35 ,visible: localStorage.getItem("ShowSaleDetailInSaleInvoice") == 'true'},
  { key: "SaleRate", label: "Sale Rate", min: 35 ,visible: localStorage.getItem("ShowSaleDetailInSaleInvoice") == 'true'},
  // { key: "SaleUnitOfMeasurement", label: "Sale UOM", min: 35 ,visible: localStorage.getItem("ShowSaleDetailInSaleInvoice") == 'true'},
      { key: 'hsCode',                          label: 'HS CODE',                                 min: 40 },
      { key: 'quantity',                        label: 'QUANTITY',                                min: 45 },
      { key: 'rate',                            label: 'RATE',                                    min: 25 },
      { key: 'amount',                          label: 'VALUE OF SALES EXCL ST',                  min: 50, visible: invoiceDetails.amountIsVisible },
      { key: 'salesTax',                        label: 'SALES TAX',                               min: 45, visible: invoiceDetails.salesTaxsVisible },
      { key: 'fixedNotifiedValueOrRetailPrice', label: 'FIXED / NOTIFIED VALUE OR RETAIL PRICE',  min: 50, visible: invoiceDetails.fixedNotifiedValueOrRetailPrice !== 0 },
      { key: 'furtherTax',                      label: 'FURTHER TAX',                             min: 45, visible: invoiceDetails.furtherTaxsVisible },
      { key: 'totalInclTax',                    label: 'TOTAL VALUE',                             min: 50, visible: invoiceDetails.totalInclTaxsVisible },
    ];

    const normalColumns = [
      { key: 'srNo',                   label: 'SR NO.',                  min: 18 },
      { key: 'FBRSaleInvoiceDetailNo', label: 'INVOICE NUMBER (DETAIL)', min: 65 },
      { key: 'description',            label: 'DOCUMENT DESCRIPTION',    min: 100 },
      // { key: "SaleProductDescription", label: "Sale Product Description", min: 55 ,visible: localStorage.getItem("ShowSaleDetailInSaleInvoice") == 'true'},
  { key: "SaleQuantity", label: "Sale Quantity", min: 35 ,visible: localStorage.getItem("ShowSaleDetailInSaleInvoice") == 'true'},
  { key: "SaleRate", label: "Sale Rate", min: 35 ,visible: localStorage.getItem("ShowSaleDetailInSaleInvoice") == 'true'},
  // { key: "SaleUnitOfMeasurement", label: "Sale UOM", min: 35 ,visible: localStorage.getItem("ShowSaleDetailInSaleInvoice") == 'true'},
      { key: 'hsCode',                 label: 'HS CODE',                 min: 40 },
      { key: 'quantity',               label: 'QUANTITY',                min: 45 },
      { key: 'rate',                   label: 'RATE',                    min: 22 },
      { key: 'amount',                 label: 'VALUE OF SALES EXCL ST',  min: 45, visible: invoiceDetails.amountIsVisible },
      { key: 'salesTax',               label: 'SALES TAX',               min: 40, visible: invoiceDetails.salesTaxsVisible },
      { key: 'extraTax',               label: 'EXTRA TAX',               min: 35, visible: invoiceDetails.extraTaxsVisible },
      { key: 'furtherTax',             label: 'FURTHER TAX',             min: 35, visible: invoiceDetails.furtherTaxsVisible },
      { key: 'fed',                    label: 'FED PAYABLE',             min: 35, visible: invoiceDetails.fedsVisible },
      { key: 'discount',               label: 'DISCOUNT',                min: 35, visible: invoiceDetails.discountsVisible },
      { key: 'totalInclTax',           label: 'TOTAL VALUE',             min: 50, visible: invoiceDetails.totalInclTaxsVisible },
    ];

    const saleTypeNormalized   = String(invoiceDetails?.saleType ?? '').replace(/\s+/g, '').toLowerCase();
    const isThirdScheduleGoods = saleTypeNormalized === '3rdschedulegoods';
    const baseColumns          = isThirdScheduleGoods ? thirdScheduleColumns : normalColumns;
    // const baseColumns          =  thirdScheduleColumns;
    const visibleColumns       = baseColumns.filter(c => c.visible !== false);

    // const totalMinWidth = visibleColumns.reduce((s, c) => s + c.min, 0);
    // const scale         = usableWidth / totalMinWidth;
    // visibleColumns.forEach(c => { c.width = Math.max(c.min * scale, c.min); });

    const totalMinWidth = visibleColumns.reduce( (sum, col) => sum + col.min, 0 );
    
    // STEP 3
    // Remaining width after minimum widths
    const remainingWidth = usableWidth - totalMinWidth;
    
    // STEP 4
    // Extra width equally divide
    const extraWidthPerColumn = remainingWidth > 0 ? remainingWidth / visibleColumns.length : 0;
    
    // STEP 5
    // Final width assign
    visibleColumns.forEach(col => {col.width = col.min + extraWidthPerColumn;});
    

    const pdfGrid = new PdfGrid();
    pdfGrid.columns.add(visibleColumns.length);
    visibleColumns.forEach((col, i) => { pdfGrid.columns.getColumn(i).width = col.width; });

    const gridHeader = pdfGrid.headers.add(1)[0];
    visibleColumns.forEach((col, i) => {
      const cell = gridHeader.cells.getCell(i);
      cell.value = col.label;
      styleHeaderCell(cell);
    });

    invoiceItems.forEach(item => {
      const row = pdfGrid.rows.addRow();
      visibleColumns.forEach((col, i) => {
        let value = item[col.key] ?? '';
        if (['amount', 'salesTax', 'extraTax', 'furtherTax', 'fed', 'discount', 'totalInclTax'].includes(col.key)) {
          value = Number(value).toLocaleString('en-US', { minimumFractionDigits: 2 });
        }
        if (col.key === 'quantity') {
          value = `${Number(item.quantity ?? 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}\n${String(item.uoM ?? '').toUpperCase()}`;
        }

        if(localStorage.getItem("ShowSaleDetailInSaleInvoice") == 'true'){
          if (col.key === "description") {
            value = `${item.description ?? ""}\n${String(item.SaleProductDescription ?? "").toUpperCase()}`;
          }
          if (col.key === "SaleRate") {
            // value = `${Number(value).toLocaleString("en-US", { minimumFractionDigits: 2 })}\n${String(item.SaleUnitOfMeasurement ?? "").toUpperCase()}`;
            const numericValue = Number(String(value).replace(/,/g, ''));

              value = `${numericValue.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}\n${String(item.SaleUnitOfMeasurement ?? "").toUpperCase()}`;
          }
        }
        // ✅ all text cell values uppercase
        row.cells.getCell(i).value = String(value).toUpperCase();
        row.cells.getCell(i).stringFormat = new PdfStringFormat(PdfTextAlignment.Center);
      });
    });

    pdfGrid.style.font = bodyFont;
    pdfGrid.style.cellPadding.all = 3;

    const layoutResult = pdfGrid.draw(page, { x: 0, y: tableStartY });

    // ==========================================
    // SECTION 4 — TOTALS BOX
    // ==========================================

    let yBase = layoutResult.bounds.y + layoutResult.bounds.height + 25;

    let xPos      = page.getClientSize().width - 250;
    let yPos      = layoutResult.bounds.height + layoutResult.bounds.y + 20;
    let boxWidth  = 220;
    let boxHeight = 140;

    graphics.drawRectangle(new PdfPen(PdfColor.black, 1), xPos, yPos, boxWidth, boxHeight);

    let lineHeight = 14;
    let padding    = 5;

    function drawRightAligned(text, yOffset, font) {
      let textWidth = font.measureString(text).width;
      let drawX     = xPos + boxWidth - padding - textWidth;
      let drawY     = yPos + yOffset;
      graphics.drawString(text.toUpperCase(), font, null, PdfBrushes.black, drawX, drawY);  // ✅ uppercase
    }

    if (isThirdScheduleGoods) {
      drawRightAligned(`VALUE OF SALES EXCL ST: ${invoiceDetails.subTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,                                                    8,                  subFont);
      drawRightAligned(`FIXED/NOTIFIED VALUE OR RETAIL PRICE: ${invoiceDetails.fixedNotifiedValueOrRetailPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8 + lineHeight * 1, subFont);
      drawRightAligned(`SALES TAX (GST): ${invoiceDetails.salesTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,                                             8 + lineHeight * 2, subFont);
      drawRightAligned(`FURTHER TAX: ${invoiceDetails.furtherTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,                                               8 + lineHeight * 3, subFont);
      if(invoiceDetails.ShowAdvanceIncomeTax  == true){
      drawRightAligned(`ADVANCE TAX U/S  ${invoiceDetails.AdvanceIncomeTaxDescription} @${invoiceDetails.AdvanceIncomeTaxPercent.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}% : ${invoiceDetails.TotalAdvanceIncomeTaxAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8 + lineHeight * 6, subFont);
      }
    } else {
      drawRightAligned(`VALUE OF SALES EXCL ST: ${invoiceDetails.subTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8,                  subFont);
      drawRightAligned(`SALES TAX (GST): ${invoiceDetails.salesTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,       8 + lineHeight * 1, subFont);
      drawRightAligned(`FURTHER TAX: ${invoiceDetails.furtherTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,         8 + lineHeight * 2, subFont);
      drawRightAligned(`EXTRA TAX: ${invoiceDetails.extraTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,             8 + lineHeight * 3, subFont);
      drawRightAligned(`FED PAYABLE: ${invoiceDetails.fedPayable.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,         8 + lineHeight * 4, subFont);
      drawRightAligned(`DISCOUNT: ${invoiceDetails.discount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,              8 + lineHeight * 5, subFont);
      if(invoiceDetails.ShowAdvanceIncomeTax  == true){
      drawRightAligned(`ADVANCE TAX U/S  ${invoiceDetails.AdvanceIncomeTaxDescription} @${invoiceDetails.AdvanceIncomeTaxPercent.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}% : ${invoiceDetails.TotalAdvanceIncomeTaxAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8 + lineHeight * 6, subFont);
      }
    }
    drawRightAligned(
      `GRAND TOTAL VALUE : RS. ${invoiceDetails.grandTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
      10 + lineHeight * 7,
      boldFont
    );

    // ===== Amount in Words =====
    graphics.drawString('TOTAL IN WORDS:', boldFont, null, blackBrush, 10, yBase);  // ✅ uppercase
    this.wrapText(
      graphics,
      String(invoiceDetails?.grandTotalInWords ?? '').toUpperCase(),  // ✅ uppercase
      boldFont,
      blackBrush,
      10,
      yBase + 15,
      300,
      15
    );

    // ==========================================
    // SECTION 5 — QR CODE + FBR LOGO + FOOTER
    // ==========================================

    const blobToBase64 = (b) => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result.split(',')[1]);
      reader.onerror = reject;
      reader.readAsDataURL(b);
    });

    const url         = URL.createObjectURL(blob);
    const response    = await fetch(url);
    if (!response.ok) throw new Error(`Failed to fetch QR: ${response.statusText}`);
    const imageBlob   = await response.blob();
    const imageBase64 = await blobToBase64(imageBlob);
    const image       = new PdfBitmap(imageBase64);
    let   xImgPos     = page.getClientSize().width - 115;
    let   yImgPos     = layoutResult.bounds.height + layoutResult.bounds.y + 170;
    graphics.drawImage(image, xImgPos, yImgPos, 96, 96);

    const FBRIMGresponse = await fetch('/fbr-img.jpg');
    if (!FBRIMGresponse.ok) throw new Error(`Failed to fetch FBR image: ${FBRIMGresponse.statusText}`);
    const FBRimageBlob   = await FBRIMGresponse.blob();
    const FBRimageBase64 = await blobToBase64(FBRimageBlob);
    const FBRimage       = new PdfBitmap(FBRimageBase64);
    graphics.drawImage(FBRimage, 40, yImgPos, 50, 50);

    graphics.drawString(
      'THIS IS A SYSTEM GENERATED DIGITAL INVOICE. NO SIGNATURE REQUIRED',  // ✅ uppercase
      subFont, null, blackBrush,
      pageWidth / 2 - 150,
      yImgPos + 150
    );
    // graphics.drawString(
    //   String(invoiceDetails.SellerRemarks ?? '').toUpperCase(),  // ✅ uppercase
    //   boldFonts, null, blackBrush,
    //   pageWidth / 2 - 40,
    //   yImgPos + 180
    // );

    // const textWidth = boldFonts.measureString(
    //   invoiceDetails.SellerRemarks
      
    // ).width;
    
    // graphics.drawString(
    //   invoiceDetails.SellerRemarks,
    //   boldFonts,
    //   null,
    //   blackBrush,
    //   pageWidth / 2 - textWidth / 2,  // Changed from: pageWidth / 2 - 40
    //   yImgPos + 180
    // );

    const remarks = invoiceDetails.SellerRemarks;

const format = new PdfStringFormat();
format.alignment = PdfTextAlignment.Center;
format.lineAlignment = PdfVerticalAlignment.Top;
format.wordWrap = PdfWordWrapType.Word;

const maxWidth = 350; 

graphics.drawString(
  String(remarks).toUpperCase(),
  boldFonts,
  null,
  blackBrush,
  pageWidth / 2 - maxWidth / 2,
  yImgPos + 170,
  maxWidth,
  100, // enough height for multiple lines
  format
);


    
    yImgPos  += 20;
    // ===== Save or Download =====
    if (type === 'save') {
      const pdfBlob = await document.save();
      document.destroy();
      return pdfBlob;
    } else {
      document.save('SalesTaxInvoiceE.pdf');
      document.destroy();
    }
  }
















  // ===============================  Sales Tax Invoice  -  Format 2 ==================================
// Main PDF generation function matching exact PDF format




async    generateSalesTaxInvoicePDF(mainSectionData ,detailSectionData , blob ,type = 'download',PdfMargins){
  
    console.log(mainSectionData)
    const document = new PdfDocument();
    
    // Page settings
    // document.pageSettings.margins = new PdfMargins(0.25, 0.25, 1.5, 0.25); // Left, Right, Top, Bottom
    // try
    document.pageSettings.margins.left = PdfMargins.Left * 72;
    document.pageSettings.margins.right = PdfMargins.Right * 72;
    document.pageSettings.margins.top = PdfMargins.Top * 72;
    document.pageSettings.margins.bottom = PdfMargins.Bottom * 72;
    // try
//     document.pageSettings.margins = {
//   top: 1.5,
//   bottom: 0.25,
//   left: 0.25,
//   right: 0.25
// };

    document.pageSettings.size = PdfPageSize.a4;
    
    const page = document.pages.add();
    const graphics = page.graphics;
    const pageWidth = page.getClientSize().width;
    
    // Define fonts exactly as in original
    // === Fonts ===
    const titleFont = new PdfStandardFont(PdfFontFamily.Helvetica, 22, PdfFontStyle.Bold);
    // const headerFont = new PdfStandardFont(PdfFontFamily.Helvetica, 11, PdfFontStyle.Bold | PdfFontStyle.Underline);
    const headerFont = new PdfStandardFont(PdfFontFamily.Helvetica, 11, PdfFontStyle.Bold );
    const normalFont = new PdfStandardFont(PdfFontFamily.Helvetica, 9);
    const smallFont = new PdfStandardFont(PdfFontFamily.Helvetica, 8);
    const boldFont = new PdfStandardFont(PdfFontFamily.Helvetica, 9, PdfFontStyle.Bold);
    
    // === Brushes & Pen ===
    const blackBrush = new PdfSolidBrush(new PdfColor(0, 0, 0));
    const blackPen = new PdfPen(new PdfColor(0, 0, 0), 1);
    const lightBlueBrush = new PdfSolidBrush(new PdfColor(0, 102, 128));
    const whiteBrush = new PdfSolidBrush(new PdfColor(255, 255, 255));
 

// ====== main Section Columns ==== 
//  invoiceNo: invoice.FBRSaleInvoiceNo || "",
//         date: invoice.invoiceDate,
//         buyerName: invoice.buyerBusinessName,
//         buyerCompany: invoice.buyerBusinessName,
//         buyerRegion: invoice.buyerProvince,
//         buyerNTN: invoice.buyerNTNCNIC,
//         buyerType: invoice.buyerRegistrationType,
//         sellerName: invoice.sellerBusinessName,
//         buyerAddress: invoice.buyerAddress,
//         sellerCompany: invoice.sellerBusinessName,
//         sellerAddress: invoice.sellerAddress,
//         sellerNTN: invoice.sellerNTNCNIC,
//         sellerRegion: invoice.sellerProvince,
//         sellerType: invoice?.sellerRegistrationType,
//         subTotal: totalvalueSalesExcludingST,
//         salesTax: totalSalesTax,
//         furtherTax: totalFurtherTax,
//         extraTax: totalExtraTax,
//         fedPayable: totalFedPayable,
//         discount: totalDiscount,
        //grandTotal: grandTotal

  // === Title ===
  let yPosition = 120;
  graphics.drawString(
    "Sales Tax Invoice",
    titleFont,
    null,
    blackBrush,
    pageWidth / 2 - 90,
    yPosition - 40
  );

  // === HR Line ===
graphics.drawLine(blackPen, 0, yPosition - 10, pageWidth, yPosition - 10);

  // === Seller & Buyer Headings ===
//   function drawUnderlinedTitle(graphics, text, font, brush, pen, x, y, padding = 0, maxWidth = 0, lineHeight = 0) {
//   let lines = [];
//   const fontSize = font.size || 12; // Get actual font size

//   if (maxWidth > 0) {
//     // Wrap text if width is provided
//     lines = wrapText(text, font, maxWidth);
//     lines.forEach((line, i) => {
//       const currentY = y + (i * lineHeight);
//       graphics.drawString(line, font, null, brush, x, currentY);
      
//       // Draw underline below each line with consistent spacing
//       const lineWidth = font.measureString(line).width;
//       const underlineY = currentY + fontSize + 2; // Small consistent gap below text
//       graphics.drawLine(pen, x, underlineY, x + lineWidth, underlineY);
//     });
//   } else {
//     graphics.drawString(text, font, null, brush, x, y);
//     lines = [text];
    
//     // Draw underline below single line with consistent positioning
//     const lineWidth = font.measureString(text).width;
//     const underlineY = y + fontSize + (padding || 2); // Consistent padding for single line
//     graphics.drawLine(pen, x, underlineY, x + lineWidth, underlineY);
//   }
// }

function drawUnderlinedTitle(
  graphics,
  text,
  font,
  brush,
  pen,
  x,
  y,
  padding = 2,
  maxWidth = 0,
  lineHeight = 16
) {
  const fontSize = font.size || 12;
  let lines = [];

  if (maxWidth > 0) {
    lines = wrapText(text, font, maxWidth);

    lines.forEach((line, i) => {
      const currentY = y + i * lineHeight;
      graphics.drawString(line, font, null, brush, x, currentY);

      if (pen) {
        const lineWidth = font.measureString(line).width;
        const underlineY = currentY + fontSize + 2;
        graphics.drawLine(pen, x, underlineY, x + lineWidth, underlineY);
      }
    });

    // 🔴 RETURN FINAL Y
    return y + lines.length * lineHeight + padding;
  } else {
    graphics.drawString(text, font, null, brush, x, y);

    if (pen) {
      const lineWidth = font.measureString(text).width;
      const underlineY = y + fontSize + padding;
      graphics.drawLine(pen, x, underlineY, x + lineWidth, underlineY);
    }

    return y + lineHeight + padding;
  }
}

function wrapText(text, font, maxWidth) {
  let words = text.split(" ");
  let line = "";
  let lines = [];

  for (let n = 0; n < words.length; n++) {
    let testLine = line + words[n] + " ";
    let testWidth = font.measureString(testLine).width || 0;

    if (testWidth > maxWidth && n > 0) {
      lines.push(line.trim());
      line = words[n] + " ";
    } else {
      line = testLine;
    }
  }
  lines.push(line.trim());
  return lines;
}
let sellerX = 0;
let buyerX = pageWidth / 2 + 10;
const lineH = 14;
const rowGap = 1;

// === HEADINGS ===
drawUnderlinedTitle(graphics, "Seller Information", headerFont, blackBrush, blackPen, sellerX, yPosition);
drawUnderlinedTitle(graphics, "Buyer Information", headerFont, blackBrush, blackPen, buyerX, yPosition);

// ===== START CONTENT BELOW HEADINGS =====
let sellerY = yPosition + 25;
let buyerY  = yPosition + 25;

// === BUSINESS NAME ===
graphics.drawString("Business Name:", normalFont, null, blackBrush, sellerX, sellerY);
sellerY = drawUnderlinedTitle(
  graphics,
  (mainSectionData?.sellerName || "").toUpperCase(),
  normalFont,
  blackBrush,
  blackPen,
  sellerX + 95,
  sellerY,
  2,
  185,
  lineH
) + rowGap;

graphics.drawString("Business Name:", normalFont, null, blackBrush, buyerX, buyerY);
buyerY = drawUnderlinedTitle(
  graphics,
  (mainSectionData?.buyerName || "").toUpperCase(),
  normalFont,
  blackBrush,
  blackPen,
  buyerX + 95,
  buyerY,
  2,
  172,
  lineH
) + rowGap;

// === ADDRESS ===
graphics.drawString("Address:", normalFont, null, blackBrush, sellerX, sellerY);
sellerY = drawUnderlinedTitle(
  graphics,
  (mainSectionData?.sellerAddress || "").toUpperCase(),
  normalFont,
  blackBrush,
  blackPen,
  sellerX + 95,
  sellerY,
  2,
  185,
  lineH
) + rowGap;

graphics.drawString("Address:", normalFont, null, blackBrush, buyerX, buyerY);
buyerY = drawUnderlinedTitle(
  graphics,
  (mainSectionData?.buyerAddress || "").toUpperCase(),
  normalFont,
  blackBrush,
  blackPen,
  buyerX + 95,
  buyerY,
  2,
  172,
  lineH
) + rowGap;

// === 
// ---------------------------
// === ALIGN BOTH SIDES ===
// ---------------------------
let commonY = Math.max(sellerY, buyerY);
sellerY = buyerY = commonY;

// ---------------------------
// === REGISTRATION & PROVINCE ===
// ---------------------------

// Seller Registration
graphics.drawString('Registration No:', normalFont, null, blackBrush, sellerX, sellerY);
sellerY = drawUnderlinedTitle(
  graphics,
  // mainSectionData?.sellerNTN || '',
  mainSectionData?.sellerNTNCNICReferenceNo &&
  mainSectionData.sellerNTNCNICReferenceNo.length >= 7
    ? mainSectionData.sellerNTNCNICReferenceNo
    : mainSectionData?.sellerNTN || '',
  normalFont,
  blackBrush,
  blackPen,
  sellerX + 95,
  sellerY
) + rowGap;

// Buyer Registration
graphics.drawString('Registration No:', normalFont, null, blackBrush, buyerX, buyerY);
buyerY = drawUnderlinedTitle(
  graphics,
  mainSectionData?.buyerNTN || '',
  normalFont,
  blackBrush,
  blackPen,
  buyerX + 95,
  buyerY
) + rowGap;

// Seller Province
graphics.drawString('Province:', normalFont, null, blackBrush, sellerX, sellerY);
sellerY = drawUnderlinedTitle(
  graphics,
  mainSectionData?.sellerRegion || '',
  normalFont,
  blackBrush,
  blackPen,
  sellerX + 95,
  sellerY
) + rowGap;

// Buyer Province
graphics.drawString('Province:', normalFont, null, blackBrush, buyerX, buyerY);
buyerY = drawUnderlinedTitle(
  graphics,
  mainSectionData?.buyerRegion || '',
  normalFont,
  blackBrush,
  blackPen,
  buyerX + 95,
  buyerY
) + rowGap;

// ---------------------------
// === FINAL HR LINE ===
// ---------------------------
commonY = Math.max(sellerY, buyerY);
graphics.drawLine(blackPen, 0, commonY + 10, pageWidth, commonY + 10);

// Update Y-position for next section
yPosition = commonY + 20;

  // === Seller Other Details ===
//   graphics.drawString('Registration No:', normalFont, null, blackBrush, sellerX, yPosition + 70);
// drawUnderlinedTitle(graphics, mainSectionData?.sellerNTN || '' , normalFont, blackBrush, blackPen, sellerX + 95, yPosition + 70);
  
// graphics.drawString('Province:', normalFont, null, blackBrush, sellerX, yPosition + 85);
// drawUnderlinedTitle(graphics, mainSectionData?.sellerRegion || '' , normalFont, blackBrush, blackPen, sellerX + 95, yPosition + 85);

//   graphics.drawString('Registration No:', normalFont, null, blackBrush, buyerX, yPosition + 70);
// Calculate business name lines for dynamic positioning

// ====== invoice summary ======
drawUnderlinedTitle(graphics, "Invoice Summary ", headerFont, blackBrush, blackPen, sellerX, yPosition );

yPosition = yPosition-130
// ===== FBR Invoice No === 
  graphics.drawString('FBR Invoice No:', normalFont, null, blackBrush, sellerX, yPosition + 161);
  graphics.drawString(mainSectionData?.invoiceNo || '', normalFont, null, blackBrush, sellerX + 80, yPosition + 161);

// ===== Invoice Date === 
  graphics.drawString('Invoice Date:', normalFont, null, blackBrush, sellerX, yPosition + 172);
  graphics.drawString(`${moment(mainSectionData.date).format("DD-MMM-YY")}` || '', normalFont, null, blackBrush, sellerX + 80, yPosition + 172);
// ===== Invoice Type === 
graphics.drawString('Invoice Type:', normalFont, null, blackBrush, sellerX, yPosition + 183);
  graphics.drawString(mainSectionData?.docDescription || '', normalFont, null, blackBrush, sellerX + 80, yPosition + 183);

// ===== Tax Period === 
graphics.drawString('Tax Period:', normalFont, null, blackBrush, sellerX, yPosition + 194);
  graphics.drawString(`${moment(mainSectionData.date).format("MMYYYY")}` || 'ask', normalFont, null, blackBrush, sellerX + 80, yPosition + 194);



  const blobToBase64 = (blob) => {
      return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result.split(',')[1]); // Extract only Base64 data
          reader.onerror = reject;
          reader.readAsDataURL(blob);
      });
    };
       // ==== FBR IMAGE DRAW ====
       const FBRIMGresponse = await fetch('/fbr-img.jpg');
       if (!FBRIMGresponse.ok) throw new Error(`Failed to fetch image: ${FBRIMGresponse.statusText}`);
       
               const FBRimageBlob = await FBRIMGresponse.blob();
               const FBRimageBase64 = await blobToBase64(FBRimageBlob);
       
              // Create PdfBitmap from Base64
              const FBRimage = new PdfBitmap(FBRimageBase64);
                
              // Draw the FBRimage on the PDF
              graphics.drawImage(FBRimage, page.getClientSize().width - 130, 0,80 ,80 ); // Adjust x, y, width, height as needed




              
    //  // ===== IMAGE (Base64 PNG) =====
    
  
  

      const url = URL.createObjectURL(blob);

      const response = await fetch(url);
      if (!response.ok) throw new Error(`Failed to fetch image: ${response.statusText}`);
    
      const imageBlob = await response.blob();
      const imageBase64 = await blobToBase64(imageBlob);
    
     // Create PdfBitmap from Base64
     const image = new PdfBitmap(imageBase64);
       
     // Draw the image on the PDF
     let xImgPos = page.getClientSize().width - 130;  // right aligned box
     let yImgPos = yPosition + 133;
     graphics.drawImage(image, xImgPos, yImgPos,144  ,144 );
    //   let yImgPos = yPosition + 137;
    //  graphics.drawImage(image, xImgPos, yImgPos,130  ,130 ); // Adjust x, y, width, height as needed
      


      // === HR Line ===
graphics.drawLine(blackPen, 0, yPosition + 230, pageWidth, yPosition + 230);




    yPosition += 250;
    
    

    
  // ====== GRID CODE ====
    // ===== ITEMS TABLE (exactly as in image) =====
    const itemsGrid = new PdfGrid();
    itemsGrid.columns.add(12);
    
    // Optimized column widths for A4 page (total ~540px for better fit)
    itemsGrid.columns.getColumn(0).width = 25;   // SR No.
    itemsGrid.columns.getColumn(1).width = 55;   // Invoice Number (Detail) - reduced
    itemsGrid.columns.getColumn(2).width = 55;   // Document Description - reduced
    itemsGrid.columns.getColumn(3).width = 40;   // HS Code
    itemsGrid.columns.getColumn(4).width = 50;   // Quantity
    itemsGrid.columns.getColumn(5).width = 28;   // UOM
    itemsGrid.columns.getColumn(6).width = 32;   // Rate
    itemsGrid.columns.getColumn(7).width = 55;   // Value of Sales Excl ST
    itemsGrid.columns.getColumn(8).width = 55;   // Sales Tax
    itemsGrid.columns.getColumn(9).width = 55;   // Extra Tax
    itemsGrid.columns.getColumn(10).width = 53;  // Further Tax
    itemsGrid.columns.getColumn(11).width = 55;  // Total Value
    
    // Header row with black background and white text as in image
    const header = itemsGrid.headers.add(1)[0];
    const headers = [
      "SR No.", "Invoice Number (Detail)", "Document Description", "HS Code", "Quantity", "UOM",
      "Rate", "Value of Sales Excl ST", "Sales Tax", "Extra Tax", "Further Tax", "Total Value"
    ];
    
    headers.forEach((h, i) => {
      header.cells.getCell(i).value = h;
      header.cells.getCell(i).style.font = new PdfStandardFont(PdfFontFamily.Helvetica, 7, PdfFontStyle.Bold); // Smaller font
      header.cells.getCell(i).style.stringFormat = new PdfStringFormat(PdfTextAlignment.Center, PdfVerticalAlignment.Middle); // Center horizontal & vertical
      header.cells.getCell(i).style.backgroundBrush = new PdfSolidBrush(new PdfColor(0, 0, 0)); // Black background
      header.cells.getCell(i).style.textBrush = new PdfSolidBrush(new PdfColor(255, 255, 255)); // White text

       // Set white border
  const whitePen = new PdfPen(new PdfColor(255, 255, 255), 0.5); // 0.5pt white border
  header.cells.getCell(i).style.borders = {
    left: i === 0 ? blackPen : whitePen,
    right:i === 11 ? blackPen : whitePen,
    top: blackPen,
    bottom: whitePen
  };

    });
    
    // Data rows from detailRows array
    detailSectionData.forEach((item, i) => {
      const row = itemsGrid.rows.addRow();
      row.cells.getCell(0).value = item.srNo.toString();
      row.cells.getCell(1).value = item.FBRSaleInvoiceDetailNo;
      row.cells.getCell(2).value = (item.description || '').toUpperCase();
      row.cells.getCell(3).value = item.hsCode;
      row.cells.getCell(4).value = item.quantity.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      row.cells.getCell(5).value = (item?.uoM || '').toUpperCase();
      row.cells.getCell(6).value = item.rate;
      row.cells.getCell(7).value = item.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      row.cells.getCell(8).value = item.salesTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      row.cells.getCell(9).value = item.extraTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      row.cells.getCell(10).value = item.furtherTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      row.cells.getCell(11).value = item.totalInclTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      
      for (let c = 0; c < row.cells.count; c++) {
        switch (c) {
          case 4:
          case 7:
          case 8:
          case 9:
          case 10:
          case 11:
           row.cells.getCell(c).stringFormat = new PdfStringFormat(PdfTextAlignment.Right, PdfVerticalAlignment.Middle);
            row.cells.getCell(c).style.cellPadding = new PdfPaddings(0, 4, 0, 0); // top, right, bottom, left
            break;
        
          default: row.cells.getCell(c).stringFormat = new PdfStringFormat(PdfTextAlignment.Center, PdfVerticalAlignment.Middle);

            break;
        }
       
        row.cells.getCell(c).style.font = new PdfStandardFont(PdfFontFamily.Helvetica, 6.5); // Smaller font for data
      }
    });
    
    // Add totals row with column spanning (0-3)
    const totalRow = itemsGrid.rows.addRow();
    
    // Merge cells 0-3 for "Total:" label with right alignment
    totalRow.cells.getCell(0).value = "Total:  ";
    totalRow.cells.getCell(0).columnSpan = 4; // Span columns 0-3
    totalRow.cells.getCell(0).style.stringFormat = new PdfStringFormat(PdfTextAlignment.Right, PdfVerticalAlignment.Middle); // Right align
    totalRow.cells.getCell(0).style.cellPadding = new PdfPaddings(0, 4, 0, 0); // top, right, bottom, left

    totalRow.cells.getCell(0).style.font = new PdfStandardFont(PdfFontFamily.Helvetica, 7, PdfFontStyle.Bold);
    
    // Set values for remaining columns (4-11)
    totalRow.cells.getCell(4).value = mainSectionData.quantity.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    totalRow.cells.getCell(5).value = ""; // UOM column empty
    totalRow.cells.getCell(6).value = ""; // Rate column empty
    totalRow.cells.getCell(7).value = mainSectionData.subTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    totalRow.cells.getCell(8).value = mainSectionData.salesTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    totalRow.cells.getCell(9).value = mainSectionData.extraTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    totalRow.cells.getCell(10).value = mainSectionData.furtherTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    totalRow.cells.getCell(11).value = mainSectionData.grandTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    
    // Style remaining cells in totals row
    for (let c = 4; c < totalRow.cells.count; c++) {
      totalRow.cells.getCell(c).stringFormat = new PdfStringFormat(PdfTextAlignment.Right, PdfVerticalAlignment.Middle);
      totalRow.cells.getCell(c).style.cellPadding = new PdfPaddings(0, 4, 0, 0); // top, right, bottom, left

      totalRow.cells.getCell(c).style.font = new PdfStandardFont(PdfFontFamily.Helvetica, 7, PdfFontStyle.Bold);
    }
    
    itemsGrid.style.font = smallFont;
    itemsGrid.style.cellPadding.all = 2; // Reduced padding for better fit
    
   let  layoutResult = itemsGrid.draw(page, { x: 0, y: yPosition });
   let yPos = layoutResult.bounds.height + layoutResult.bounds.y; 

   const italicFont = new PdfStandardFont(PdfFontFamily.Helvetica, 9, PdfFontStyle.Italic);
const blueBrush = new PdfSolidBrush(new PdfColor(83, 132, 208)); // #5384d0

graphics.drawString(
  'This is system generated Digital Invoice. No signature required.',
  italicFont,
  null,
  blueBrush,
  0,
  yPos + 30
);


 

    
    // ===== SAVE DOCUMENT =====
    if (type === 'save') {
      const pdfBlob = await document.save();
      document.destroy();
      return pdfBlob;
    } else {
      let partyName = (mainSectionData?.buyerName || '')
  .toUpperCase()
  .split(/\s+/)[0]; 

      document.save(`INV_${partyName}_${mainSectionData?.invoiceNo}.pdf`);
      document.destroy();
    }
  }



















// ===============================  Sales Tax Invoice  -  Format 2 ==================================

//   async  generateSalesTaxInvoicePDF(mainSectionData ,detailSectionData , blob ,type = 'download',PdfMargins) {
//     console.log(mainSectionData)
//     const document = new PdfDocument();
    
//     // Page settings
//     // document.pageSettings.margins = new PdfMargins(0.25, 0.25, 1.5, 0.25); // Left, Right, Top, Bottom
//     // try
//     document.pageSettings.margins.left = PdfMargins.Left * 72;
//     document.pageSettings.margins.right = PdfMargins.Right * 72;
//     document.pageSettings.margins.top = PdfMargins.Top * 72;
//     document.pageSettings.margins.bottom = PdfMargins.Bottom * 72;
//     // try
// //     document.pageSettings.margins = {
// //   top: 1.5,
// //   bottom: 0.25,
// //   left: 0.25,
// //   right: 0.25
// // };

//     document.pageSettings.size = PdfPageSize.a4;
    
//     const page = document.pages.add();
//     const graphics = page.graphics;
//     const pageWidth = page.getClientSize().width;
    
//     // Define fonts exactly as in original
//     // === Fonts ===
//     const titleFont = new PdfStandardFont(PdfFontFamily.Helvetica, 22, PdfFontStyle.Bold);
//     // const headerFont = new PdfStandardFont(PdfFontFamily.Helvetica, 11, PdfFontStyle.Bold | PdfFontStyle.Underline);
//     const headerFont = new PdfStandardFont(PdfFontFamily.Helvetica, 11, PdfFontStyle.Bold );
//     const normalFont = new PdfStandardFont(PdfFontFamily.Helvetica, 9);
//     const smallFont = new PdfStandardFont(PdfFontFamily.Helvetica, 8);
//     const boldFont = new PdfStandardFont(PdfFontFamily.Helvetica, 9, PdfFontStyle.Bold);
    
//     // === Brushes & Pen ===
//     const blackBrush = new PdfSolidBrush(new PdfColor(0, 0, 0));
//     const blackPen = new PdfPen(new PdfColor(0, 0, 0), 1);
//     const lightBlueBrush = new PdfSolidBrush(new PdfColor(0, 102, 128));
//     const whiteBrush = new PdfSolidBrush(new PdfColor(255, 255, 255));
 

// // ====== main Section Columns ==== 
// //  invoiceNo: invoice.FBRSaleInvoiceNo || "",
// //         date: invoice.invoiceDate,
// //         buyerName: invoice.buyerBusinessName,
// //         buyerCompany: invoice.buyerBusinessName,
// //         buyerRegion: invoice.buyerProvince,
// //         buyerNTN: invoice.buyerNTNCNIC,
// //         buyerType: invoice.buyerRegistrationType,
// //         sellerName: invoice.sellerBusinessName,
// //         buyerAddress: invoice.buyerAddress,
// //         sellerCompany: invoice.sellerBusinessName,
// //         sellerAddress: invoice.sellerAddress,
// //         sellerNTN: invoice.sellerNTNCNIC,
// //         sellerRegion: invoice.sellerProvince,
// //         sellerType: invoice?.sellerRegistrationType,
// //         subTotal: totalvalueSalesExcludingST,
// //         salesTax: totalSalesTax,
// //         furtherTax: totalFurtherTax,
// //         extraTax: totalExtraTax,
// //         fedPayable: totalFedPayable,
// //         discount: totalDiscount,
//         //grandTotal: grandTotal

//   // === Title ===
//   let yPosition = 120;
//   graphics.drawString(
//     "Sales Tax Invoice",
//     titleFont,
//     null,
//     blackBrush,
//     pageWidth / 2 - 90,
//     yPosition - 40
//   );

//   // === HR Line ===
// graphics.drawLine(blackPen, 0, yPosition - 10, pageWidth, yPosition - 10);

//   // === Seller & Buyer Headings ===
//   function drawUnderlinedTitle(graphics, text, font, brush, pen, x, y, padding = 0, maxWidth = 0, lineHeight = 0) {
//   let lines = [];
//   const fontSize = font.size || 12; // Get actual font size

//   if (maxWidth > 0) {
//     // Wrap text if width is provided
//     lines = wrapText(text, font, maxWidth);
//     lines.forEach((line, i) => {
//       const currentY = y + (i * lineHeight);
//       graphics.drawString(line, font, null, brush, x, currentY);
      
//       // Draw underline below each line with consistent spacing
//       const lineWidth = font.measureString(line).width;
//       const underlineY = currentY + fontSize + 2; // Small consistent gap below text
//       graphics.drawLine(pen, x, underlineY, x + lineWidth, underlineY);
//     });
//   } else {
//     graphics.drawString(text, font, null, brush, x, y);
//     lines = [text];
    
//     // Draw underline below single line with consistent positioning
//     const lineWidth = font.measureString(text).width;
//     const underlineY = y + fontSize + (padding || 2); // Consistent padding for single line
//     graphics.drawLine(pen, x, underlineY, x + lineWidth, underlineY);
//   }
// }

// function wrapText(text, font, maxWidth) {
//   let words = text.split(" ");
//   let line = "";
//   let lines = [];

//   for (let n = 0; n < words.length; n++) {
//     let testLine = line + words[n] + " ";
//     let testWidth = font.measureString(testLine).width || 0;

//     if (testWidth > maxWidth && n > 0) {
//       lines.push(line.trim());
//       line = words[n] + " ";
//     } else {
//       line = testLine;
//     }
//   }
//   lines.push(line.trim());
//   return lines;
// }

//   let sellerX = 0;
//   let buyerX = pageWidth / 2 + 20;
  
// drawUnderlinedTitle(graphics, "Seller Information", headerFont, blackBrush, blackPen, sellerX, yPosition);
// drawUnderlinedTitle(graphics, "Buyer Information", headerFont, blackBrush, blackPen, buyerX, yPosition);


//   // === Seller Business Name (with wrapping) ===
  
//     graphics.drawString('Business Name:', normalFont, null, blackBrush, sellerX, yPosition + 20);
//     drawUnderlinedTitle(graphics, (mainSectionData?.sellerName || '').toUpperCase() , normalFont, blackBrush, blackPen, sellerX + 95, yPosition + 20);

//   // === Buyer Busniess  Name (with wrapping) ===
// graphics.drawString('Business Name:', normalFont, null, blackBrush, buyerX, yPosition + 20);
// drawUnderlinedTitle(graphics, (mainSectionData?.buyerName || '').toUpperCase() , normalFont, blackBrush, blackPen, buyerX + 95, yPosition + 20);


//   // === Seller Address (with wrapping) ===
//    graphics.drawString('Address:', normalFont, null, blackBrush, sellerX, yPosition + 35);
//     drawUnderlinedTitle(graphics, 
//       (mainSectionData?.sellerAddress || '').toUpperCase() , 
//       // (`Mr. A. B, House No. 5, Block A, Gulshan-e-Iqbal, Karachi-75290, Sindh, Pakistan` || '').toUpperCase() , 
//       // `Mr. A. B. Khan, House No. 5, Street No. 12, Block A, Gulshan-e-Iqbal, Karachi-75290, Sindh, Pakistan`,
//       // `mainSectionData?.buyerAddres`,
//       // ` (mainSectionData?.sellerAddress || '').toUpperCase() D`, 
//       normalFont, blackBrush, blackPen, sellerX + 95, yPosition + 35,  4,                // padding below last line
//       185,              // max width for wrapping
//       16   ); 


// // === Buyer Address (with wrapping) ===
// graphics.drawString('Address:', normalFont, null, blackBrush, buyerX, yPosition + 35);
// drawUnderlinedTitle(
//   graphics,
//   (mainSectionData?.buyerAddress || '').toUpperCase(),
//   // (`Mr. A. B, House No. 5, Block A, Gulshan-e-Iqbal, Sindh, Pakistan , karachi !` || '').toUpperCase(),
//  // `mainSectionData?.buyerAddress`,
//   normalFont,
//   blackBrush,
//   blackPen,         // pass null if you don't want underline
//   buyerX + 95,
//   yPosition + 35,
//   5,                // padding below last line
//   172,              // max width for wrapping
//   16                // line height (e.g., font.size + 4)
// );


//   // === Seller Other Details ===
// //   graphics.drawString('Registration No:', normalFont, null, blackBrush, sellerX, yPosition + 70);
// // drawUnderlinedTitle(graphics, mainSectionData?.sellerNTN || '' , normalFont, blackBrush, blackPen, sellerX + 95, yPosition + 70);
  
// // graphics.drawString('Province:', normalFont, null, blackBrush, sellerX, yPosition + 85);
// // drawUnderlinedTitle(graphics, mainSectionData?.sellerRegion || '' , normalFont, blackBrush, blackPen, sellerX + 95, yPosition + 85);

// //   graphics.drawString('Registration No:', normalFont, null, blackBrush, buyerX, yPosition + 70);

// let sellerAddressWidth = normalFont.measureString(mainSectionData?.sellerAddress || '').width;

// function estimateWrappedLines(text, font, maxLineWidth) {
//   const words = text.split(' ');
//   let lineCount = 0;
//   let currentLine = '';

//   for (let word of words) {
//     let testLine = currentLine ? currentLine + ' ' + word : word;
//     let testWidth = font.measureString(testLine).width;

//     if (testWidth <= maxLineWidth) {
//       currentLine = testLine;
//     } else {
//       lineCount++;
//       currentLine = word;
//     }
//   }

//   return lineCount;
// }

// // Apply to your seller address
// let sellerAddressText = (mainSectionData?.sellerAddress || '').toUpperCase();
// // let sellerAddressText = (`Mr. A. B, House No. 5, Block A, Gulshan-e-Iqbal, Karachi-75290, Sindh, Pakistan` || '').toUpperCase();
// // let sellerAddressText = ` (mainSectionData?.sellerAddress || '').toUpperCase() D fgg gfggfg gdffd dfdfdf dffdf gfdfdfdsd`;
// // let sellerAddressText = (
// //   mainSectionData?.sellerAddress
// //   || '').toUpperCase();
// let estimatedLines = estimateWrappedLines(sellerAddressText, normalFont, 185);
// console.log('Accurate estimated lines:', estimatedLines);

//  let BuyerAddressText = (
//    mainSectionData?.buyerAddress
  
//   || '').toUpperCase();
// let estimatedLinesBuyer = estimateWrappedLines(BuyerAddressText, normalFont, 171);
// console.log('Accurate estimated lines For Buyer:', estimatedLinesBuyer);
// let maxEstimatedLines = Math.max(estimatedLines, estimatedLinesBuyer);
// // Calculate dynamic Y offset
// let lineHeight = 16;
// let registrationYOffset = yPosition + 50 + ((maxEstimatedLines) * lineHeight);
//   console.log('Registration Y Offset:', registrationYOffset);


// // // ====== ONE LINE MARGIN OLD CODE ===
// //   graphics.drawString('Registration No:', normalFont, null, blackBrush, sellerX,  sellerAddressWidth < 169 ? yPosition + 50 : yPosition + 70);
// // drawUnderlinedTitle(graphics, mainSectionData?.sellerNTN || '' , normalFont, blackBrush, blackPen, sellerX + 95, sellerAddressWidth < 169 ? yPosition + 50 : yPosition + 70);
// // ====== ONE LINE MARGIN OLD CODE ===  

// graphics.drawString('Registration No:', normalFont, null, blackBrush, sellerX,  registrationYOffset);
// drawUnderlinedTitle(graphics, mainSectionData?.sellerNTN || '' , normalFont, blackBrush, blackPen, sellerX + 95, registrationYOffset);



// // ====== ONE LINE MARGIN OLD CODE ===  
// // graphics.drawString('Province:', normalFont, null, blackBrush, sellerX, sellerAddressWidth < 169 ? yPosition + 65 : yPosition + 85);
// // drawUnderlinedTitle(graphics, mainSectionData?.sellerRegion || '' , normalFont, blackBrush, blackPen, sellerX + 95, sellerAddressWidth < 169 ? yPosition + 65 : yPosition + 85);
// // ====== ONE LINE MARGIN OLD CODE ===  

// graphics.drawString('Province:', normalFont, null, blackBrush, sellerX,registrationYOffset + 15);
// drawUnderlinedTitle(graphics, mainSectionData?.sellerRegion || '' , normalFont, blackBrush, blackPen, sellerX + 95, registrationYOffset + 15);

//   // === Buyer Other Details ===

 
//   // let BuyerAddressText = (
//   // `Mr. A. B, House No. 5, Block A, Gulshan-e-Iqbal, Sindh, Pakistan`
//   // || '').toUpperCase();
//   // let BuyerAddressText = (
//   // ` (?. || '').toUpperCase() D fgg gfggfg gdffd dfdsd`
//   // || '').toUpperCase();


// // Calculate dynamic Y offset
// let lineHeightBuyer = 16;
// let registrationYOffsetBuyer = yPosition + 50 + ((maxEstimatedLines) * lineHeightBuyer);
//   console.log('Registration Y Offset:', registrationYOffsetBuyer);


//   let buyerAddressWidth = normalFont.measureString(mainSectionData?.buyerAddress || '').width;
//   // console.log(buyerAddressWidth)
//   //   graphics.drawString('Registration No:', normalFont, null, blackBrush, buyerX, yPosition + 70);
//     graphics.drawString('Registration No:', normalFont, null, blackBrush, buyerX,  registrationYOffsetBuyer);
// drawUnderlinedTitle(graphics, mainSectionData?.buyerNTN || '' , normalFont, blackBrush, blackPen, buyerX + 95, registrationYOffsetBuyer);
  
// graphics.drawString('Province:', normalFont, null, blackBrush, buyerX,registrationYOffsetBuyer + 15);
// drawUnderlinedTitle(graphics, mainSectionData?.buyerRegion || '' , normalFont, blackBrush, blackPen, buyerX + 95, registrationYOffsetBuyer  + 15);



//  // === HR Line ===
//  let gapInLine = Math.max(estimatedLinesBuyer, estimatedLines) * 15;
//  let drawlineHeight = estimatedLinesBuyer > 0 || estimatedLines > 0 ? yPosition + 100 + gapInLine : yPosition + 100;
// graphics.drawLine(blackPen, 0, drawlineHeight, pageWidth, drawlineHeight);

// yPosition = estimatedLinesBuyer > 0 || estimatedLines > 0  ? yPosition + gapInLine - 15 : yPosition -  15;

// // ====== invoice summary ======
// drawUnderlinedTitle(graphics, "Invoice Summary ", headerFont, blackBrush, blackPen, sellerX, yPosition + 130);

 
// // ===== FBR Invoice No === 
//   graphics.drawString('FBR Invoice No:', normalFont, null, blackBrush, sellerX, yPosition + 161);
//   graphics.drawString(mainSectionData?.invoiceNo || '', normalFont, null, blackBrush, sellerX + 80, yPosition + 161);

// // ===== Invoice Date === 
//   graphics.drawString('Invoice Date:', normalFont, null, blackBrush, sellerX, yPosition + 172);
//   graphics.drawString(`${moment(mainSectionData.date).format("DD-MMM-YY")}` || '', normalFont, null, blackBrush, sellerX + 80, yPosition + 172);
// // ===== Invoice Type === 
// graphics.drawString('Invoice Type:', normalFont, null, blackBrush, sellerX, yPosition + 183);
//   graphics.drawString(mainSectionData?.docDescription || '', normalFont, null, blackBrush, sellerX + 80, yPosition + 183);

// // ===== Tax Period === 
// graphics.drawString('Tax Period:', normalFont, null, blackBrush, sellerX, yPosition + 194);
//   graphics.drawString(`${moment(mainSectionData.date).format("MMYYYY")}` || 'ask', normalFont, null, blackBrush, sellerX + 80, yPosition + 194);



//   const blobToBase64 = (blob) => {
//       return new Promise((resolve, reject) => {
//           const reader = new FileReader();
//           reader.onloadend = () => resolve(reader.result.split(',')[1]); // Extract only Base64 data
//           reader.onerror = reject;
//           reader.readAsDataURL(blob);
//       });
//     };
//        // ==== FBR IMAGE DRAW ====
//        const FBRIMGresponse = await fetch('/fbr-img.jpg');
//        if (!FBRIMGresponse.ok) throw new Error(`Failed to fetch image: ${FBRIMGresponse.statusText}`);
       
//                const FBRimageBlob = await FBRIMGresponse.blob();
//                const FBRimageBase64 = await blobToBase64(FBRimageBlob);
       
//               // Create PdfBitmap from Base64
//               const FBRimage = new PdfBitmap(FBRimageBase64);
                
//               // Draw the FBRimage on the PDF
//               graphics.drawImage(FBRimage, page.getClientSize().width - 130, 0,80 ,80 ); // Adjust x, y, width, height as needed




              
//     //  // ===== IMAGE (Base64 PNG) =====
    
  
  

//       const url = URL.createObjectURL(blob);

//       const response = await fetch(url);
//       if (!response.ok) throw new Error(`Failed to fetch image: ${response.statusText}`);
    
//       const imageBlob = await response.blob();
//       const imageBase64 = await blobToBase64(imageBlob);
    
//      // Create PdfBitmap from Base64
//      const image = new PdfBitmap(imageBase64);
       
//      // Draw the image on the PDF
//      let xImgPos = page.getClientSize().width - 130;  // right aligned box
//      let yImgPos = yPosition + 155;
//      graphics.drawImage(image, xImgPos, yImgPos,72  ,72 );
//     //   let yImgPos = yPosition + 137;
//     //  graphics.drawImage(image, xImgPos, yImgPos,130  ,130 ); // Adjust x, y, width, height as needed
      


//       // === HR Line ===
// graphics.drawLine(blackPen, 0, yPosition + 240, pageWidth, yPosition + 240);




//     yPosition += 260;
    
    

    
//   // ====== GRID CODE ====
//     // ===== ITEMS TABLE (exactly as in image) =====
//     const itemsGrid = new PdfGrid();
//     itemsGrid.columns.add(12);
    
//     // Optimized column widths for A4 page (total ~540px for better fit)
//     itemsGrid.columns.getColumn(0).width = 25;   // SR No.
//     itemsGrid.columns.getColumn(1).width = 55;   // Invoice Number (Detail) - reduced
//     itemsGrid.columns.getColumn(2).width = 55;   // Document Description - reduced
//     itemsGrid.columns.getColumn(3).width = 40;   // HS Code
//     itemsGrid.columns.getColumn(4).width = 50;   // Quantity
//     itemsGrid.columns.getColumn(5).width = 28;   // UOM
//     itemsGrid.columns.getColumn(6).width = 32;   // Rate
//     itemsGrid.columns.getColumn(7).width = 55;   // Value of Sales Excl ST
//     itemsGrid.columns.getColumn(8).width = 55;   // Sales Tax
//     itemsGrid.columns.getColumn(9).width = 55;   // Extra Tax
//     itemsGrid.columns.getColumn(10).width = 53;  // Further Tax
//     itemsGrid.columns.getColumn(11).width = 55;  // Total Value
    
//     // Header row with black background and white text as in image
//     const header = itemsGrid.headers.add(1)[0];
//     const headers = [
//       "SR No.", "Invoice Number (Detail)", "Document Description", "HS Code", "Quantity", "UOM",
//       "Rate", "Value of Sales Excl ST", "Sales Tax", "Extra Tax", "Further Tax", "Total Value"
//     ];
    
//     headers.forEach((h, i) => {
//       header.cells.getCell(i).value = h;
//       header.cells.getCell(i).style.font = new PdfStandardFont(PdfFontFamily.Helvetica, 7, PdfFontStyle.Bold); // Smaller font
//       header.cells.getCell(i).style.stringFormat = new PdfStringFormat(PdfTextAlignment.Center, PdfVerticalAlignment.Middle); // Center horizontal & vertical
//       header.cells.getCell(i).style.backgroundBrush = new PdfSolidBrush(new PdfColor(0, 0, 0)); // Black background
//       header.cells.getCell(i).style.textBrush = new PdfSolidBrush(new PdfColor(255, 255, 255)); // White text

//        // Set white border
//   const whitePen = new PdfPen(new PdfColor(255, 255, 255), 0.5); // 0.5pt white border
//   header.cells.getCell(i).style.borders = {
//     left: i === 0 ? blackPen : whitePen,
//     right:i === 11 ? blackPen : whitePen,
//     top: blackPen,
//     bottom: whitePen
//   };

//     });
    
//     // Data rows from detailRows array
//     detailSectionData.forEach((item, i) => {
//       const row = itemsGrid.rows.addRow();
//       row.cells.getCell(0).value = item.srNo.toString();
//       row.cells.getCell(1).value = item.FBRSaleInvoiceDetailNo;
//       row.cells.getCell(2).value = item.description;
//       row.cells.getCell(3).value = item.hsCode;
//       row.cells.getCell(4).value = item.quantity.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//       row.cells.getCell(5).value = item?.uoM || '';
//       row.cells.getCell(6).value = item.rate;
//       row.cells.getCell(7).value = item.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//       row.cells.getCell(8).value = item.salesTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//       row.cells.getCell(9).value = item.extraTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//       row.cells.getCell(10).value = item.furtherTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//       row.cells.getCell(11).value = item.totalInclTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      
//       for (let c = 0; c < row.cells.count; c++) {
//         switch (c) {
//           case 4:
//           case 7:
//           case 8:
//           case 9:
//           case 10:
//           case 11:
//            row.cells.getCell(c).stringFormat = new PdfStringFormat(PdfTextAlignment.Right, PdfVerticalAlignment.Middle);
//             row.cells.getCell(c).style.cellPadding = new PdfPaddings(0, 4, 0, 0); // top, right, bottom, left
//             break;
        
//           default: row.cells.getCell(c).stringFormat = new PdfStringFormat(PdfTextAlignment.Center, PdfVerticalAlignment.Middle);

//             break;
//         }
       
//         row.cells.getCell(c).style.font = new PdfStandardFont(PdfFontFamily.Helvetica, 6.5); // Smaller font for data
//       }
//     });
    
//     // Add totals row with column spanning (0-3)
//     const totalRow = itemsGrid.rows.addRow();
    
//     // Merge cells 0-3 for "Total:" label with right alignment
//     totalRow.cells.getCell(0).value = "Total:  ";
//     totalRow.cells.getCell(0).columnSpan = 4; // Span columns 0-3
//     totalRow.cells.getCell(0).style.stringFormat = new PdfStringFormat(PdfTextAlignment.Right, PdfVerticalAlignment.Middle); // Right align
//     totalRow.cells.getCell(0).style.cellPadding = new PdfPaddings(0, 4, 0, 0); // top, right, bottom, left

//     totalRow.cells.getCell(0).style.font = new PdfStandardFont(PdfFontFamily.Helvetica, 7, PdfFontStyle.Bold);
    
//     // Set values for remaining columns (4-11)
//     totalRow.cells.getCell(4).value = mainSectionData.quantity.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//     totalRow.cells.getCell(5).value = ""; // UOM column empty
//     totalRow.cells.getCell(6).value = ""; // Rate column empty
//     totalRow.cells.getCell(7).value = mainSectionData.subTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//     totalRow.cells.getCell(8).value = mainSectionData.salesTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//     totalRow.cells.getCell(9).value = mainSectionData.extraTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//     totalRow.cells.getCell(10).value = mainSectionData.furtherTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//     totalRow.cells.getCell(11).value = mainSectionData.grandTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    
//     // Style remaining cells in totals row
//     for (let c = 4; c < totalRow.cells.count; c++) {
//       totalRow.cells.getCell(c).stringFormat = new PdfStringFormat(PdfTextAlignment.Right, PdfVerticalAlignment.Middle);
//       totalRow.cells.getCell(c).style.cellPadding = new PdfPaddings(0, 4, 0, 0); // top, right, bottom, left

//       totalRow.cells.getCell(c).style.font = new PdfStandardFont(PdfFontFamily.Helvetica, 7, PdfFontStyle.Bold);
//     }
    
//     itemsGrid.style.font = smallFont;
//     itemsGrid.style.cellPadding.all = 2; // Reduced padding for better fit
    
//    let  layoutResult = itemsGrid.draw(page, { x: 0, y: yPosition });
//    let yPos = layoutResult.bounds.height + layoutResult.bounds.y; 

//    const italicFont = new PdfStandardFont(PdfFontFamily.Helvetica, 9, PdfFontStyle.Italic);
// const blueBrush = new PdfSolidBrush(new PdfColor(83, 132, 208)); // #5384d0

// graphics.drawString(
//   'This is system generated Digital Invoice. No signature required.',
//   italicFont,
//   null,
//   blueBrush,
//   0,
//   yPos + 30
// );


 

    
//     // ===== SAVE DOCUMENT =====
//     if (type === 'save') {
//       const pdfBlob = await document.save();
//       document.destroy();
//       return pdfBlob;
//     } else {
//       let partyName = (mainSectionData?.buyerName || '')
//   .toUpperCase()
//   .split(/\s+/)[0]; 

//       document.save(`INV_${partyName}_${mainSectionData?.invoiceNo}.pdf`);
//       document.destroy();
//     }
//   }

  // Sample data matching exact PDF format
 

}

export default new SaleInvoiceService();